/*
 * ff-flow-data.js — data layer for the new step flow.
 *
 * Loaded *after* new-flow.js (handoff JS that wires UI animations &
 * format checks). This file owns:
 *   • Loading zones.json from WP (cached in sessionStorage)
 *   • Postcode → zone lookup (2090)
 *   • localStorage persistence under the `ffNewFlow.*` namespace
 *   • Continue-button navigation between steps
 *
 * localStorage keys:
 *   ffNewFlow.suburb     — { postcode, suburb, state, warehouse_location,
 *                            delivery_day, depot, provider, packing_day }
 *   ffNewFlow.household  — { adults, children }
 *   ffNewFlow.frequency  — "weekly" | "fortnightly"
 *   ffNewFlow.dietary    — "none" | "vegetarian" | "vegan"
 */
(function () {
  // Portal Swap allowlist — only these subscription IDs see the rescue-box
  // card + drawer entry button + portal swap logic. Everyone else uses the
  // legacy edit flow. Test cohort while the feature stabilises.
  var FF_PORTAL_SWAP_ALLOWED = [
      '38384304189', '56523653181', '78203355197', '42943938621', '39660617789', '89133613117',
      '72584331325', '79619784765', '79622766653', '48424157245', '92837806141', '45294813245',
      '90739376189', '84652359741', '2789376061', '2873065533', '2951315517', '3127017533',
      '3148873789', '3204382781', '3269656637', '3281059901', '3290955837', '3383722045',
      '3440410685', '3724116029', '3801972797', '3881730109', '3919577149', '3932880957',
      '3968925757', '5201363005', '5217779773', '5270798397', '5622988861', '5649137725',
      '5743116349', '5768871997', '5785878589', '5804589117', '5847646269', '5879988285',
      '6047268925', '6061293629', '6234538045', '6312067133', '6331334717', '6419972157',
      '7074906173', '7333773373', '7386333245', '7535067197', '7800094781', '8352727101',
      '10416586813', '11134828605', '11190370365', '12112592957', '12419268669', '13341786173',
      '13548224573', '13851426877', '14113013821', '14479032381', '14540537917', '14771322941',
      '14876901437', '15030026301', '15225684029', '15499821117', '16057630781', '16097214525',
      '16097574973', '16364109885', '16747593789', '17089364029', '17518362685', '17813340221',
      '18396217405', '18933973053', '18973294653', '19062718525', '19229343805', '19688390717',
      '19798753341', '19835027517', '20513554493', '21758312509', '21919563837', '23144955965',
      '23311646781', '23423877181', '23924080701', '26618101821', '27443560509', '27445198909',
      '27479244861', '27563753533', '27623882813', '27830911037', '28070740029', '28075229245',
      '28374499389', '29098934333', '29122822205', '29171974205', '29271687229', '29406527549',
      '29533077565', '29572202557', '29773496381', '29780344893', '29781655613', '29792075837',
      '30168547389', '30168842301', '30236901437', '30292377661', '30302306365', '30397071421',
      '30401757245', '30476271677', '30693589053', '30892064829', '30896980029', '30954160189',
      '31033688125', '31037259837', '31075500093', '31083266109', '31089164349', '31105351741',
      '31111020605', '31180030013', '31261032509', '31261622333', '31357796413', '31461376061',
      '31475073085', '31808684093', '31951487037', '32117522493', '32140263485', '32314196029',
      '32612155453', '32673628221', '32784547901', '33039417405', '33404682301', '33411465277',
      '33597947965', '33718337597', '33850884157', '33969111101', '34699935805', '34725396541',
      '34806464573', '35010019389', '35013066813', '35111829565', '35188736061', '35196174397',
      '35522314301', '35656302653', '35970973757', '36106829885', '36249141309', '36268965949',
      '36566695997', '36697800765', '36864065597', '36867571773', '36947066941', '37226610749',
      '37321801789', '37959860285', '38392004669', '38642483261', '39250100285', '39463911485',
      '39562543165', '39712522301', '39716061245', '39804993597', '39927349309', '40111505469',
      '40218361917', '40220721213', '40585691197', '40594997309', '40843182141', '40853798973',
      '40963211325', '40965570621', '41774415933', '42410442813', '42426171453', '42531225661',
      '42612326461', '42648633405', '42858414141', '43425169469', '43597004861', '43637375037',
      '43788238909', '43993759805', '44769968189', '44771934269', '44798345277', '44899663933',
      '45189824573', '45367656509', '45507510333', '45541457981', '45771063357', '45917929533',
      '46120861757', '46459781181', '46526824509', '46859616317', '47079096381', '47291924541',
      '47363850301', '47394914365', '47643164733', '47654567997', '47746973757', '48032841789',
      '48251502653', '48253599805', '48497557565', '48702357565', '48749215805', '48784015421',
      '48864362557', '49202626621', '49290248253', '49476239421', '50011897917', '50110464061',
      '50289606717', '50477957181', '50727321661', '51000836157', '51023183933', '52934901821',
      '53080358973', '54469886013', '54996893757', '55146709053', '55275290685', '55419240509',
      '55440834621', '55656087613', '55657234493', '55773298749', '55871832125', '56061296701',
      '56428527677', '56764203069', '56795988029', '56927060029', '57303564349', '57393217597',
      '57525960765', '57974554685', '58076332093', '58078003261', '58175324221', '58594525245',
      '59043086397', '59049377853', '59053178941', '59522646077', '59524907069', '59593687101',
      '59698905149', '59796783165', '59800191037', '59908259901', '60366487613', '60374777917',
      '60459974717', '61233987645', '61236510781', '61349199933', '61490921533', '61566713917',
      '61578707005', '61691068477', '62058266685', '62241701949', '62759927869', '63592759357',
      '63828590653', '63847891005', '64298516541', '64828178493', '64852361277', '67105620029',
      '67201400893', '67389915197', '67627581501', '67820355645', '68475682877', '68968284221',
      '69218271293', '69399511101', '69539856445', '69882806333', '69901844541', '69917933629',
      '70056411197', '70065029181', '70154551357', '70161399869', '70168576061', '70172999741',
      '70272778301', '70294700093', '70352240701', '70425313341', '70493536317', '70595608637',
      '70596132925', '70983057469', '71006289981', '71015170109', '71022051389', '71028113469',
      '71112491069', '71188873277', '71190151229', '71236747325', '71242645565', '71247953981',
      '71382237245', '71482409021', '71582941245', '71620395069', '71634354237', '71749992509',
      '71815954493', '72057913405', '72075345981', '72274280509', '72294891581', '72314716221',
      '72567849021', '72682242109', '72714551357', '72841494589', '72956936253', '72957689917',
      '73042133053', '73085681725', '73200336957', '73607512125', '73627303997', '74368679997',
      '74435264573', '74471833661', '74476355645', '74477207613', '74477797437', '74829398077',
      '74856661053', '74956144701', '74963550269', '75069161533', '75279401021', '75333828669',
      '75852775485', '75889672253', '75890098237', '75898912829', '76138971197', '76467503165',
      '76490506301', '76491391037', '76771786813', '76824969277', '76931301437', '76932284477',
      '76953452605', '76963971133', '77049036861', '77087113277', '77102481469', '77194592317',
      '77217759293', '77706952765', '77715439677', '77785104445', '77940228157', '77959594045',
      '78047805501', '78081491005', '78196375613', '78198702141', '78443774013', '78456193085',
      '78474870845', '78485454909', '78583169085', '78594637885', '78738128957', '78874607677',
      '78885552189', '78894006333', '79132262461', '79361114173', '79480455229', '79514828861',
      '79722283069', '79733063741', '79822913597', '79924133949', '80293167165', '80415391805',
      '80434462781', '80551608381', '80566845501', '80622780477', '80870342717', '80915300413',
      '81204150333', '81297571901', '81497620541', '81589993533', '81723621437', '81773232189',
      '81897750589', '81909776445', '81993433149', '82112315453', '82223562813', '82309611581',
      '82321178685', '82350833725', '82399461437', '82517983293', '82846449725', '82866634813',
      '82866929725', '83103776829', '83280035901', '83292618813', '83314212925', '83404619837',
      '83478511677', '83506004029', '83611189309', '83614793789', '83679641661', '83885883453',
      '83980288061', '84207665213', '84333527101', '84437401661', '84537344061', '84538523709',
      '84541898813', '84642758717', '84689453117', '84791459901', '84794540093', '84890517565',
      '84911390781', '84912472125', '84981219389', '85029683261', '85113667645', '85141127229',
      '85155708989', '85159379005', '85160132669', '85235138621', '85246509117', '85259157565',
      '85263876157', '85280391229', '85291597885', '85347172413', '85509701693', '85512290365',
      '85522415677', '85528805437', '85627502653', '85661384765', '85874343997', '85893480509',
      '86015901757', '86132555837', '86162014269', '86341386301', '86356525117', '86357409853',
      '86358851645', '86368518205', '86373269565', '86445785149', '86473244733', '86482747453',
      '86551920701', '86573711421', '86590816317', '86685384765', '86688333885', '86828286013',
      '86828482621', '86864789565', '86868394045', '86882385981', '87019094077', '87034560573',
      '87036297277', '87038066749', '87056646205', '87192830013', '87232479293', '87367057469',
      '87402577981', '87407231037', '87408443453', '87420796989', '87495409725', '87547609149',
      '87653875773', '87742152765', '87751295037', '88004493373', '88125833277', '88169381949',
      '88393744445', '88430870589', '88436506685', '88494800957', '88547852349', '88557060157',
      '88617156669', '88666898493', '88668045373', '88671256637', '88690950205', '88807440445',
      '88841519165', '88917540925', '88942379069', '88955191357', '88959549501', '88970362941',
      '89076367421', '89112444989', '89198002237', '89519718461', '89639518269', '89684410429',
      '89766920253', '90149060669', '90188054589', '90299564093', '90546634813', '90624131133',
      '90694484029', '90704379965', '90706903101', '90710638653', '90739081277', '90746617917',
      '90782400573', '90968719421', '91108868157', '91283750973', '91301904445', '91303870525',
      '91306229821', '91307212861', '91388084285', '91396866109', '91441463357', '91443888189',
      '91825504317', '91861712957', '91976663101', '91980791869', '91985838141', '92002451517',
      '92076245053', '92111405117', '92118319165', '92241756221', '92250079293', '92268625981',
      '92272623677', '92365750333', '92418965565', '92442296381', '92568813629', '92682911805',
      '92716924989', '92851994685', '92862283837', '92867100733', '92877062205', '92881027133',
      '92883615805', '92891447357', '92976676925', '92997353533', '93029335101', '93032611901',
      '93034217533', '93131243581', '93149593661', '93179412541', '93307568189', '93317300285',
      '93426876477', '93453746237', '93583867965', '93597073469', '93609427005', '93733191741',
      '93742825533', '93834346557', '93838082109', '93857579069', '93860495421', '93956243517',
      '93967548477', '94093213757', '94097145917'
    ];
  (function () {
    try {
      var sid = new URLSearchParams(window.location.search).get('subscriptionId');
      if (!sid) return;
      // Allowlist retired 2026-07-XX — swap feature open to every
      // subscription. Any URL with a subscriptionId qualifies now.
      // FF_PORTAL_SWAP_ALLOWED kept above as a historical reference but
      // no longer consulted here.
      document.documentElement.classList.add('ff-portal-swap-enabled');
    } catch (e) {}
  })();

  // Prefer Shopify Files CDN URLs (populated by theme.liquid from
  // shop.metafields.funky_data.*, refreshed on every WP cron run).
  // Falls back to the legacy Kinsta REST endpoint if the metafield
  // hasn't been set yet (safety net, no user-visible change).
  var _FF_URLS = (window.__ffDataUrls || {});
  var ZONES_URL = _FF_URLS.zones || 'https://funkyfood-public-data.janfemac1122.workers.dev/zones-json/';
  var SS_ZONES_KEY = 'ffNewFlow.zonesCache';
  var SS_ZONES_TTL = 6 * 60 * 60 * 1000; // 6 hours

  // ---------- Storage helpers ----------
  function lsGet(k) {
    try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; }
  }
  function lsSet(k, v) {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }
  function ssGet(k) {
    try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; }
  }
  function ssSet(k, v) {
    try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }

  // ---------- Navigation helper ----------
  // Add the spinner class to the clicked button (.ff-btn.is-loading is already
  // styled in new-flow.css) right before leaving the page, so the user gets
  // immediate feedback during the cross-page navigation.
  function goWithLoading(url, btn, delayMs) {
    // Preserve the current URL's query string when navigating to a
    // sibling step page. The reactivate-subscription flow lands on
    // /pages/new-step-1-suburb?token=…&subscriptionId=…&rebuild=true
    // and those params must survive every next-step click so the final
    // step knows to REBUILD an existing contract instead of creating a
    // new one. Same-origin path targets only, and only when the target
    // doesn't already carry its own querystring.
    var target = url;
    try {
      if (target && target.charAt(0) === '/' && target.indexOf('?') === -1) {
        var cur = window.location.search || '';
        if (cur.length > 1) target += cur;
      }
    } catch (e) {}
    if (btn && btn.classList) btn.classList.add('is-loading');
    if (delayMs) {
      setTimeout(function () { window.location.href = target; }, delayMs);
    } else {
      window.location.href = target;
    }
  }

  // Browser back / iOS swipe-back restores the page from bfcache with the
  // DOM snapshot intact, so the is-loading spinner added by goWithLoading
  // would stay on forever (same issue steps-scripts.liquid fixes for the
  // legacy .loading class).
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('.ff-btn.is-loading').forEach(function (el) {
      el.classList.remove('is-loading');
    });
    // Same bfcache trap for the full-screen "building your box" overlay: leaving
    // a step via a [data-show-loading] button sets #loading + .is-active, so a
    // browser back (e.g. step 4 order → step 3 dietary) restores the DOM with the
    // overlay still open. Force it closed and drop the stale hash.
    document.querySelectorAll('.ff-loading-overlay.is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    document.body.classList.remove('ff-no-scroll');
    if (window.location.hash === '#loading') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  });

  // ---------- Zones loader (with sessionStorage cache) ----------
  var _zonesPromise = null;
  function loadZones() {
    if (_zonesPromise) return _zonesPromise;
    var cached = ssGet(SS_ZONES_KEY);
    if (cached && cached.cachedAt && (Date.now() - cached.cachedAt < SS_ZONES_TTL) && Array.isArray(cached.zones)) {
      _zonesPromise = Promise.resolve(cached.zones);
      return _zonesPromise;
    }
    _zonesPromise = fetch(ZONES_URL, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('zones HTTP ' + r.status); return r.json(); })
      .then(function (data) {
        var zones = (data && data.zones) || [];
        ssSet(SS_ZONES_KEY, { cachedAt: Date.now(), zones: zones });
        return zones;
      })
      .catch(function (e) { console.error('ff-flow-data: load zones failed', e); _zonesPromise = null; return []; });
    return _zonesPromise;
  }

  // Start loading zones immediately on script execution so they're warm
  // by the time the user finishes typing 4 digits.
  loadZones();

  // ---------- 2090: suburb autocomplete + zone lookup ----------
  function init2090() {
    var section = document.querySelector('.ff-postcode-section[data-ff-step="suburb"]');
    if (!section) return;
    var root = document.querySelector('[data-state]');
    var input = section.querySelector('[data-postcode-input]');
    var continueBtn = section.querySelector('[data-ff-continue]');
    var dayEl = section.querySelector('[data-ff-delivery-day]');
    var listEl = section.querySelector('.ff-suburb-suggestions');
    if (!input || !root || !listEl) return;

    // macOS Safari rubber-band fix: Safari keeps its native elastic bounce on
    // inner scrollers even with overscroll-behavior:contain, so at the list's
    // scroll boundary the bounce pulls out blank space and reveals the button
    // behind. Clamp boundary overscroll at the source by cancelling the wheel/
    // touch delta that would scroll past the top/bottom edge.
    function ffAtScrollEdge(deltaUp, deltaDown) {
      var atTop = listEl.scrollTop <= 0;
      var atBottom = listEl.scrollHeight - listEl.clientHeight - listEl.scrollTop <= 0;
      return (atTop && deltaUp) || (atBottom && deltaDown);
    }
    listEl.addEventListener('wheel', function (e) {
      if (ffAtScrollEdge(e.deltaY < 0, e.deltaY > 0)) e.preventDefault();
    }, { passive: false });
    var ffTouchY = 0;
    listEl.addEventListener('touchstart', function (e) {
      ffTouchY = e.touches[0].clientY;
    }, { passive: true });
    listEl.addEventListener('touchmove', function (e) {
      var dy = e.touches[0].clientY - ffTouchY; // dy > 0 = finger down = scroll up
      if (ffAtScrollEdge(dy > 0, dy < 0)) e.preventDefault();
    }, { passive: false });

    // Mark Continue button as "wired by 2090" so the generic Continue
    // handler later won't navigate without saving the zone first.
    if (continueBtn) continueBtn.dataset.ffWired = '1';

    var field = section.querySelector('.ff-suburb-field');
    var currentZone = null;
    var activeIdx = -1;
    var nextUrl = (continueBtn && continueBtn.getAttribute('data-ff-continue')) || '/pages/new-step-1-household';

    function clearError() {
      if (field) field.classList.remove('ff-suburb-field--error');
    }
    // Invalid / unserviced postcode → red border (mirrors the old flow's
    // input.error). Stays in the "initial" state so Continue won't navigate.
    function showError() {
      currentZone = null;
      root.setAttribute('data-state', 'initial');
      if (field) field.classList.add('ff-suburb-field--error');
    }

    function applyValidated(zone) {
      currentZone = zone;
      clearError();
      if (dayEl) dayEl.textContent = (zone.delivery_day || '').trim();
      root.setAttribute('data-state', 'validated');
      input.setAttribute('aria-expanded', 'false');
    }
    function applyInitial() {
      currentZone = null;
      root.setAttribute('data-state', 'initial');
    }
    // Unserviced postcode → swap the page copy to the waiting-list message
    // in place (no navigation). Typing again resets to 'initial' via check(),
    // so the user can immediately try another postcode.
    function applyNoDelivery() {
      currentZone = null;
      clearError();
      hideList();
      root.setAttribute('data-state', 'no-delivery');
      input.setAttribute('aria-expanded', 'false');
    }

    // Decide whether the typed value unambiguously identifies a zone.
    function pickAuto(v, matches) {
      if (/^\d{4}$/.test(v) && matches.length) return matches[0];
      if (matches.length === 1) return matches[0];
      if (matches.length > 1) {
        var lc = v.toLowerCase();
        var exact = matches.filter(function (z) {
          return String(z.suburb || '').toLowerCase() === lc;
        });
        if (exact.length === 1) return exact[0];
      }
      return null;
    }

    function hideList() {
      listEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIdx = -1;
    }
    function showList() {
      listEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function renderSuggestions(matches) {
      listEl.innerHTML = '';
      if (!matches.length) { hideList(); return; }
      matches.forEach(function (z, i) {
        var li = document.createElement('li');
        li.className = 'ff-suburb-suggestion';
        li.setAttribute('role', 'option');
        li.dataset.idx = String(i);
        var name = document.createElement('span');
        name.textContent = (z.suburb || '') + (z.state ? ', ' + z.state : '');
        var meta = document.createElement('span');
        meta.className = 'ff-suburb-suggestion__meta';
        meta.textContent = String(z.postcode || '');
        li.appendChild(name);
        li.appendChild(meta);
        li.addEventListener('mousedown', function (e) {
          // mousedown (not click) so it fires before input blur
          e.preventDefault();
          selectMatch(z);
        });
        listEl.appendChild(li);
      });
      showList();
    }

    function selectMatch(z) {
      input.value = (z.suburb || '') + (z.state ? ', ' + z.state : '') + (z.postcode ? ' ' + z.postcode : '');
      hideList();
      if (isOutOfService(z)) { applyNoDelivery(); return; }
      applyValidated(z);
      // Picking a suggestion commits straight away — same as Get started.
      if (save()) goWithLoading(nextUrl, continueBtn);
    }

    function isOutOfService(z) {
      // Supabase marks unserviced postcodes with the literal string
      // "Out of Service Area" on delivery_day or provider. Treat these
      // exactly like "not in the zone table at all".
      return (z.delivery_day === 'Out of Service Area') ||
             (z.provider === 'Out of Service Area');
    }
    function matchZones(zones, query) {
      var q = query.trim().toLowerCase();
      if (!q) return [];
      var isPostcode = /^\d{1,4}$/.test(q);
      var seen = {};
      var out = [];
      for (var i = 0; i < zones.length && out.length < 8; i++) {
        var z = zones[i];
        /* out-of-service zones kept so the user can pick one and be routed to no-delivery */
        var pc = String(z.postcode || '');
        var sb = String(z.suburb || '').toLowerCase();
        var match = isPostcode ? pc.indexOf(q) === 0 : sb.indexOf(q) !== -1;
        if (!match) continue;
        // Dedupe by suburb + postcode (zone table can have repeats for
        // delivery_day_2 variants etc).
        var key = sb + '|' + pc;
        if (seen[key]) continue;
        seen[key] = 1;
        out.push(z);
      }
      return out;
    }

    function check() {
      var v = (input.value || '').trim();
      clearError();
      if (!v) { applyInitial(); hideList(); return; }
      currentZone = null;
      applyInitial();
      loadZones().then(function (zones) {
        // Ignore stale results if the field changed while zones loaded.
        if (v !== (input.value || '').trim()) return;
        var matches = matchZones(zones, v);
        renderSuggestions(matches);
        // Auto-detect: validate the moment the input unambiguously
        // identifies a zone (see pickAuto); if a full 4-digit postcode
        // matches no serviceable zone, flag it red immediately instead
        // of waiting for the user to submit.
        var auto = pickAuto(v, matches);
        // Out-of-service zones are left in the suggestion list but NOT
        // auto-switched while typing — the no-delivery message only appears
        // when the user explicitly picks one from the dropdown (selectMatch).
        if (auto && !isOutOfService(auto)) {
          applyValidated(auto);
        } else if (/^\d{4}$/.test(v) && !matches.length) {
          showError();
        }
      });
    }

    // Commit attempt (Enter / Get started). Navigate when a zone is
    // resolved; otherwise flag the input as an error and stay put.
    function commit() {
      var v = (input.value || '').trim();
      if (!v) { showError(); input.focus(); return; }
      if (currentZone) { if (save()) goWithLoading(nextUrl, continueBtn); return; }
      // Zone not resolved yet (still typing fast / zones loading) — resolve
      // synchronously against the loaded table before deciding.
      loadZones().then(function (zones) {
        var auto = pickAuto(v, matchZones(zones, v));
        if (auto && isOutOfService(auto)) {
          applyNoDelivery();
        } else if (auto) {
          applyValidated(auto);
          if (save()) goWithLoading(nextUrl, continueBtn);
        } else {
          showError();
        }
      });
    }

    input.addEventListener('input', check);
    input.addEventListener('focus', function () {
      if (listEl.children.length) showList();
    });
    input.addEventListener('blur', function () {
      // delay so mousedown on a row can fire first
      setTimeout(hideList, 150);
    });
    input.addEventListener('keydown', function (e) {
      var rows = listEl.querySelectorAll('.ff-suburb-suggestion');
      // Enter commits: pick the highlighted suggestion, else validate/submit.
      if (e.key === 'Enter') {
        e.preventDefault();
        if (activeIdx >= 0 && rows[activeIdx]) {
          rows[activeIdx].dispatchEvent(new MouseEvent('mousedown'));
        } else {
          commit();
        }
        return;
      }
      if (!rows.length) return;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIdx = (activeIdx + 1) % rows.length;
        rows.forEach(function (r, i) { r.classList.toggle('is-active', i === activeIdx); });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIdx = (activeIdx - 1 + rows.length) % rows.length;
        rows.forEach(function (r, i) { r.classList.toggle('is-active', i === activeIdx); });
      } else if (e.key === 'Escape') {
        hideList();
      }
    });

    function save() {
      if (!currentZone) return false;
      var z = currentZone;
      lsSet('ffNewFlow.suburb', {
        postcode: String(z.postcode || ''),
        suburb: z.suburb || '',
        state: z.state || '',
        warehouse_location: (z.warehouse_location || '').toLowerCase(),
        delivery_day: z.delivery_day || '',
        depot: z.depot || '',
        provider: z.provider || '',
        packing_day: z.packing_day || z.label_making_day || '',
        billing_day: z.billing_day || '',
        zone: z.zone || '',
        savedAt: Date.now(),
      });
      // Legacy compatibility: mirror to `localStepInfo` so the existing
      // collection grid + cart modal can keep region-filtering products
      // (depot/provider lookups in main-collection-product-grid.liquid
      // and cart-modal-slider.liquid). Field names match the old flow.
      var suburbValtext = (z.suburb || '') +
        (z.state ? ', ' + z.state : '') +
        (z.postcode ? ' ' + z.postcode : '');
      lsSet('localStepInfo', [{
        suburbCity: z.suburb || '',
        suburbState: z.state || '',
        suburbPostcode: String(z.postcode || ''),
        suburbValtext: suburbValtext,
        depot: z.depot || '',
        provider: z.provider || '',
        zoneDay: z.delivery_day || '',
        zoneDay2: z.delivery_day_2 || '',
      }]);
      return true;
    }

    if (continueBtn) {
      continueBtn.addEventListener('click', function () { commit(); });
    }

    // Re-hydrate from localStorage on back-nav.
    var prior = lsGet('ffNewFlow.suburb');
    if (prior && prior.suburb) {
      input.value = prior.suburb + (prior.state ? ', ' + prior.state : '') + (prior.postcode ? ' ' + prior.postcode : '');
      if (prior.noDelivery) {
        // Saved address matched a zone but isn't serviceable. Keep the
        // input filled, show the no-delivery copy, but don't restore
        // currentZone so the Continue button can't navigate.
        applyNoDelivery();
      } else {
        // Treat as already validated without re-querying (avoids dropdown flash)
        currentZone = prior;
        applyValidated(prior);
      }
    }
  }

  // ---------- Generic Continue button (other steps) ----------
  // For non-2090 steps we just need navigation. State saving for those
  // steps will be added in the per-step initializers below.
  function initGenericContinue() {
    document.querySelectorAll('[data-ff-continue]').forEach(function (btn) {
      // Skip if already handled by a step-specific initializer (2090)
      if (btn.dataset.ffWired === '1') return;
      var url = btn.getAttribute('data-ff-continue');
      if (!url) return;
      btn.addEventListener('click', function () { goWithLoading(url, btn); });
    });
  }

  // ---------- 2092: household counters ----------
  // Client-supplied recommendation algorithm v1.
  // See wp-content/uploads/funkyfood-data/onboarding-recommendation-algorithm.md
  // for the spec and worked examples. Constants are kept here for now;
  // when tuning is requested post-launch, move them to theme settings.
  // Spec defaults; live values come from window.__ffBoxRecConfig which
  // ff-box-data.liquid emits from theme settings. parseFloat with
  // fallback handles blank / non-numeric setting values gracefully.
  var BOX_REC_DEFAULTS = {
    ADULT_UNIT: 1.0,
    CHILD_UNIT: 0.6,
    KG_PER_UNIT_WEEK: 3.5,
    DIET_UPLIFT: 1.15,
    FORTNIGHT_MULT: 1.7,
  };
  var BOX_REC = (function () {
    var src = window.__ffBoxRecConfig || {};
    var out = {};
    Object.keys(BOX_REC_DEFAULTS).forEach(function (k) {
      var raw = src[k];
      var n = parseFloat(raw);
      out[k] = (isFinite(n) && n > 0) ? n : BOX_REC_DEFAULTS[k];
    });
    return out;
  })();

  // Slot keys per settings_data: meat X/S/M/B = Small/Medium/Big/Beef Only; Beef Only is never recommended.
  var MEAT_FOR_VEG = { X: 'X', S: 'X', M: 'S', B: 'M' };

  function computeBoxRecommendation(state) {
    var adults = Math.max(1, Number((state && state.adults) || 0));
    var children = Math.max(0, Number((state && state.children) || 0));
    var diet = (state && state.diet) || 'none';
    var frequency = (state && state.frequency) || 'weekly';

    var units = (adults * BOX_REC.ADULT_UNIT) + (children * BOX_REC.CHILD_UNIT);
    var dietUplift = (diet === 'vegetarian' || diet === 'vegan') ? BOX_REC.DIET_UPLIFT : 1.0;
    var weeklyKg = units * BOX_REC.KG_PER_UNIT_WEEK * dietUplift;
    var cycleKg = frequency === 'fortnightly' ? weeklyKg * BOX_REC.FORTNIGHT_MULT : weeklyKg;

    var fvBox, nudge = false;
    if (cycleKg <= 4.0)       fvBox = 'X';
    else if (cycleKg <= 7.5)  fvBox = 'S';
    else if (cycleKg <= 12.0) fvBox = 'M';
    else if (cycleKg <= 16.0) fvBox = 'B';
    else { fvBox = 'B'; nudge = true; }

    var meatIncluded = (diet === 'none');
    var meatSize = null;
    if (meatIncluded) {
      meatSize = MEAT_FOR_VEG[fvBox];
    }
    return {
      fvBox: fvBox,
      meatIncluded: meatIncluded,
      meatSize: meatSize,
      nudgeToWeekly: nudge,
      cycleKg: Math.round(cycleKg * 100) / 100,
    };
  }

  // Wipe the user's manual size override so 2095 falls back to whatever
  // computeBoxRecommendation last produced. Called whenever the user
  // actually changes household / frequency / dietary inputs.
  function clearManualBoxSize() {
    try { localStorage.removeItem('ffNewFlow.boxSizes'); } catch (e) {}
    try { localStorage.removeItem('ffNewFlow.chosenSize'); } catch (e) {}
  }

  function persistBoxRecommendation() {
    var household = lsGet('ffNewFlow.household') || {};
    var freqRaw = lsGet('ffNewFlow.frequency');
    var rec = computeBoxRecommendation({
      adults: household.adults,
      children: household.children,
      diet: lsGet('ffNewFlow.dietary') || 'none',
      frequency: (freqRaw && typeof freqRaw === 'object') ? freqRaw.value : (freqRaw || 'weekly'),
    });
    lsSet('ffNewFlow.recommendation', rec);
    lsSet('ffNewFlow.recommendedSize', rec.fvBox);
    // Stored even when meat is excluded: readers fall back to the veg key, which would pair Big veg with Beef Only.
    lsSet('ffNewFlow.recommendedMeatSize', MEAT_FOR_VEG[rec.fvBox]);
  }

  function init2092() {
    var section = document.querySelector('[data-ff-step="household"]');
    if (!section) return;
    var continueBtn = section.parentNode.querySelector('[data-ff-continue]') ||
                      document.querySelector('.ff-actions [data-ff-continue]');
    var qtys = section.querySelectorAll('.ff-qty[data-key]');
    if (!qtys.length) return;

    function readQtys() {
      var out = { adults: 1, children: 0 };
      qtys.forEach(function (qty) {
        var key = qty.getAttribute('data-key');
        var v = parseInt((qty.querySelector('.ff-qty__value') || {}).value || '0', 10);
        out[key] = isNaN(v) ? 0 : v;
      });
      return out;
    }
    function writeQtys(state) {
      qtys.forEach(function (qty) {
        var key = qty.getAttribute('data-key');
        if (!(key in state)) return;
        var valueEl = qty.querySelector('.ff-qty__value');
        if (!valueEl) return;
        valueEl.value = String(state[key]);
        var minus = qty.querySelector('[data-action="dec"]');
        var plus = qty.querySelector('[data-action="inc"]');
        var min = parseInt(qty.getAttribute('data-min') || '0', 10);
        var max = parseInt(qty.getAttribute('data-max') || '10', 10);
        if (minus) minus.disabled = state[key] <= min;
        if (plus) plus.disabled = state[key] >= max;
      });
    }

    // Hydrate from prior session
    var prior = lsGet('ffNewFlow.household');
    if (prior) writeQtys(prior);

    function save() {
      var s = readQtys();
      var prior = lsGet('ffNewFlow.household') || {};
      var changed = Number(prior.adults) !== Number(s.adults) ||
                    Number(prior.children) !== Number(s.children);
      lsSet('ffNewFlow.household', { adults: s.adults, children: s.children, savedAt: Date.now() });
      if (changed) clearManualBoxSize();
      persistBoxRecommendation();
    }

    if (continueBtn) {
      continueBtn.dataset.ffWired = '1';
      var nextUrl = continueBtn.getAttribute('data-ff-continue') || '/pages/new-step-2-frequency';
      continueBtn.addEventListener('click', function () {
        save();
        goWithLoading(nextUrl, continueBtn);
      });
    }
  }

  // ---------- 2093 + 2094: single-select radio groups ----------
  function initSingleSelect(stepKey, lsKey, defaultUrl, opts) {
    opts = opts || {};
    var section = document.querySelector('[data-ff-step="' + stepKey + '"]');
    if (!section) return;
    var group = section.querySelector('.ff-options');
    var continueBtn = document.querySelector('.ff-actions [data-ff-continue]');
    if (!group || !continueBtn) return;
    var options = group.querySelectorAll('.ff-option[data-value]');

    function currentValue() {
      var sel = group.querySelector('.ff-option.is-selected');
      return sel ? sel.getAttribute('data-value') : null;
    }
    function selectValue(val) {
      if (!val) return;
      options.forEach(function (o) {
        var match = o.getAttribute('data-value') === val;
        o.classList.toggle('is-selected', match);
        o.setAttribute('aria-checked', match ? 'true' : 'false');
      });
    }

    // Hydrate — accept both string and {value, ...} payload shapes.
    var prior = lsGet(lsKey);
    var priorVal = prior && typeof prior === 'object' ? prior.value : prior;
    if (priorVal) selectValue(priorVal);

    continueBtn.dataset.ffWired = '1';
    var nextUrl = continueBtn.getAttribute('data-ff-continue') || defaultUrl;
    continueBtn.addEventListener('click', function () {
      var val = currentValue();
      // Detect a real input change vs "Continue without touching anything":
      // compare the selected value against what was saved last time. If it
      // differs, this step's input is now different from the snapshot the
      // user's previous recommendation/manual choice was based on, so
      // any manual size override is dropped.
      var priorPayload = lsGet(lsKey);
      var priorVal = (priorPayload && typeof priorPayload === 'object') ? priorPayload.value : priorPayload;
      var stepChanged = !!val && val !== priorVal;
      if (val) {
        var payload = val;
        // For the frequency step, also attach the matching selling-plan ID
        // (from selling-plan-config.liquid → window.__sellingPlans) so
        // 2095 can hand it to the cart without re-looking-up.
        if (stepKey === 'frequency' && window.__sellingPlans && window.__sellingPlans[val]) {
          payload = { value: val, sellingPlanId: window.__sellingPlans[val] };
        }
        lsSet(lsKey, payload);
      }
      // Reaching 2095 via the dietary Continue button clears any prior
      // "I removed the meat box" / "I removed the veg box" choices — gives
      // the user a way to undo an accidental close by going back one step
      // and continuing again.
      if (stepKey === 'dietary') {
        try { localStorage.removeItem('ffNewFlow.hideMeatBox'); } catch (e) {}
        try { localStorage.removeItem('ffNewFlow.hideVegBox'); } catch (e) {}
      }
      // Frequency and dietary both feed into the box recommendation
      // formula. If the user actually changed this input, wipe the manual
      // size so 2095 picks up the fresh recommendation; otherwise leave
      // the manual choice alone.
      if (stepKey === 'frequency' || stepKey === 'dietary') {
        if (stepChanged) clearManualBoxSize();
        try { persistBoxRecommendation(); } catch (e) {}
      }
      goWithLoading(nextUrl, continueBtn, opts.delayMs);
    });
  }

  // ---------- 2095: order review ----------
  // Legacy Kinsta URL kept only as a last-resort. Any unrecognised
  // warehouse value falls back to the Brisbane CDN JSON rather than the
  // Kinsta REST endpoint, because Brisbane data is a safer default than
  // hammering the WP host — the CDN JSON only misses items that are
  // uniquely stocked in that specific warehouse.
  var MENU_URL = 'https://funkyfood-public-data.janfemac1122.workers.dev/weekly-menu/?warehouse=';
  function _menuUrlFor(wh) {
    if (wh === 'brisbane'  && _FF_URLS.weeklyMenuBrisbane)  return _FF_URLS.weeklyMenuBrisbane;
    if (wh === 'melbourne' && _FF_URLS.weeklyMenuMelbourne) return _FF_URLS.weeklyMenuMelbourne;
    // Unknown / non-standard warehouse — prefer the Brisbane CDN JSON
    // (metafield) over the Kinsta live endpoint to keep WP hits at zero.
    if (_FF_URLS.weeklyMenuBrisbane) return _FF_URLS.weeklyMenuBrisbane;
    return MENU_URL + encodeURIComponent(wh);
  }

  var ITEMS_MAP_URL   = _FF_URLS.itemsMap    || 'https://funkyfood-public-data.janfemac1122.workers.dev/items-map/';
  var SUGGESTIONS_URL = _FF_URLS.suggestions || 'https://funkyfood-public-data.janfemac1122.workers.dev/exclusion-swap-suggestions/';

  var _itemsMapPromise = null;
  function loadItemsMap() {
    if (_itemsMapPromise) return _itemsMapPromise;
    // Shopify Files URLs are content-hashed via ?v=<ts> — the URL
    // itself changes on every cron update, so CDN caching is safe
    // and no cache-bust is needed. On the Kinsta fallback path a
    // stale response is acceptable (1h edge TTL from our functions.php
    // Cache-Control change).
    _itemsMapPromise = fetch(ITEMS_MAP_URL, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('items-map HTTP ' + r.status); return r.json(); })
      .catch(function (e) { console.error('ff-flow-data: load items-map failed', e); _itemsMapPromise = null; return null; });
    return _itemsMapPromise;
  }

  var _suggestionsPromise = null;
  function loadSuggestions() {
    if (_suggestionsPromise) return _suggestionsPromise;
    _suggestionsPromise = fetch(SUGGESTIONS_URL, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('suggestions HTTP ' + r.status); return r.json(); })
      .catch(function (e) { console.error('ff-flow-data: load suggestions failed', e); _suggestionsPromise = null; return null; });
    return _suggestionsPromise;
  }

  // Swap-window helpers (spec FF Portal Swaps — Tech Specification):
  // - Opens delivery_date − 6 days, at 4pm Brisbane for Tuesday deliveries,
  //   12pm Brisbane for all other days.
  // - Closes label_making_date at 6am Brisbane.
  // Brisbane = UTC+10 fixed (no DST).
  function _toBrisbaneDate(dateStr, hour, minute) {
    var p = String(dateStr || '').split('-');
    if (p.length !== 3) return null;
    var y = +p[0], m = +p[1] - 1, d = +p[2];
    if (isNaN(y) || isNaN(m) || isNaN(d)) return null;
    return new Date(Date.UTC(y, m, d, hour - 10, minute || 0, 0));
  }
  // Compute open/close swap window. Open = delivery_date − 6 days in
  // Brisbane wall time, at 4pm (Tuesday delivery zones) or 12pm (others).
  // Close = label_making_date 6am Brisbane. Bug history: previously
  // subtracted 6 days on the UTC instant of Brisbane-midnight, then
  // pulled .getUTCDate() — which returns the UTC calendar date (one day
  // earlier than Brisbane after the subtraction), so the open instant
  // landed a day too early. Compute the open Y-M-D on the Brisbane
  // calendar before reusing _toBrisbaneDate.
  function _addBrisbaneDays(dateStr, days) {
    var p = String(dateStr || '').split('-');
    if (p.length !== 3) return null;
    var y = +p[0], m = +p[1] - 1, d = +p[2];
    if (isNaN(y) || isNaN(m) || isNaN(d)) return null;
    var ms = Date.UTC(y, m, d) + days * 86400000;
    var nd = new Date(ms);
    var yy = nd.getUTCFullYear();
    var mm = String(nd.getUTCMonth() + 1).padStart(2, '0');
    var dd = String(nd.getUTCDate()).padStart(2, '0');
    return yy + '-' + mm + '-' + dd;
  }
  function computeSwapWindow(box) {
    if (!box || !box.delivery_date || !box.billing_date) return null;
    var deliveryMidnightUTC = _toBrisbaneDate(box.delivery_date, 0);
    if (!deliveryMidnightUTC) return null;
    var dow = new Date(deliveryMidnightUTC.getTime() + 10 * 3600000).getUTCDay();
    // Tuesday delivery → open 4pm (delivery-6d). All other days → 00:01am
    // (just-past-midnight) the same calendar day, so the window covers the
    // whole day instead of being chopped off at noon.
    var openHour   = (dow === 2) ? 16 : 0;
    var openMinute = (dow === 2) ? 0  : 1;
    var openDateStr = _addBrisbaneDays(box.delivery_date, -6);
    var openTime = _toBrisbaneDate(openDateStr, openHour, openMinute);
    // Close = billing_date 18:00 Brisbane. Per-store billing fires
    // around 21:00 (some at 20:00 due to TZ drift); 18:00 gives a 2–3h
    // buffer ahead of the actual charge so size/exclusion/extras edits
    // can't reach the cycle that's already being billed.
    var closeTime = _toBrisbaneDate(box.billing_date, 20);
    return { open: openTime, close: closeTime, openHour: openHour, openMinute: openMinute };
  }
  function isInSwapWindow(win) {
    if (!win || !win.open || !win.close) return false;
    var now = Date.now();
    return now >= win.open.getTime() && now < win.close.getTime();
  }
  function formatLockedDate(date) {
    var now = Date.now();
    var diffDays = Math.ceil((date.getTime() - now) / 86400000);
    var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    if (diffDays <= 7 && diffDays > 0) return days[date.getUTCDay()];
    // Brisbane wall date for the open-time instant
    var brisMs = date.getTime() + 10 * 3600000;
    var brisDate = new Date(brisMs);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return brisDate.getUTCDate() + ' ' + months[brisDate.getUTCMonth()];
  }
  function formatLockedTime(openHour, openMinute) {
    if (openHour === 16) return '4pm';
    if (openHour === 0 && (openMinute || 0) === 1) return '12:01am';
    if (openHour === 0) return '12am';
    if (openHour === 12) return '12pm';
    return (openHour > 12 ? (openHour - 12) + 'pm' : openHour + 'am');
  }

  // Size-lock removed — box-size + Exclusions are editable anytime per
  // updated requirement. Swap-window gating (computeSwapWindow /
  // isInSwapWindow) now decides whether Supabase commits fire; outside
  // the window changes only flow to Appstle, not Supabase.
  function applySizeLockState(box) {
    var locked = false;
    document.body.classList.toggle('ff-size-locked', locked);
  }

  // Build Supabase-shape add_ons from the current localCart. Excludes the
  // veg variety box (its contents live in final_items). Everything else
  // — meat box, fruit add-ons, eggs, bread, etc. — flows through here.
  //   • line_id is null for now (Appstle assigns the SubscriptionLine id
  //     after the Worker writes; line_id reconciliation is deferred).
  //   • One-time = sellingPlan === 'none' (or missing) → both
  //     selling_plan_id and selling_plan_name are null, matching the
  //     Supabase format observed in samples.
  function buildAddOnsFromLocalCart() {
    var lcRaw;
    try { lcRaw = localStorage.getItem('localCart'); } catch (e) { return []; }
    var lc;
    try { lc = lcRaw ? JSON.parse(lcRaw) : []; } catch (e) { return []; }
    if (!Array.isArray(lc)) return [];
    var vegPids = {};
    var sizeMap = (window.__ffBoxData && window.__ffBoxData.veg) || {};
    Object.keys(sizeMap).forEach(function (k) {
      var pid = sizeMap[k] && sizeMap[k].id;
      if (pid) vegPids[String(pid)] = 1;
    });
    var out = [];
    lc.forEach(function (it) {
      if (!it) return;
      var pid = String(it.productId || '');
      if (!pid || vegPids[pid]) return;
      var vid = it.variantId || it.id;
      if (!vid) return;
      var sp = it.sellingPlan;
      var isOneTime = !sp || sp === 'none';
      out.push({
        price: String(it.price == null ? '' : it.price),
        title: it.productName || '',
        line_id: null,
        quantity: Number(it.quantity) || 0,
        product_id: 'gid://shopify/Product/' + pid,
        variant_id: 'gid://shopify/ProductVariant/' + vid,
        selling_plan_id: isOneTime ? null : ('gid://shopify/SellingPlan/' + sp),
        selling_plan_name: isOneTime ? null : (it.sellingPlanName || null)
      });
    });
    return out;
  }
  // Fetch the next customer_boxes row whose swap-window opens
  // strictly after `now` — used to compute the Locked Screen date.
  function fetchNextSwapBox(sid, afterDateISO) {
    var SB_URL = 'https://eaagqdyrbdlahjzdppdk.supabase.co';
    var SB_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVhYWdxZHlyYmRsYWhqemRwcGRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc1OTk3NDEsImV4cCI6MjA4MzE3NTc0MX0.tnteB3igOKfgXKGTDEfRiq7TcxZIKLe3wSufhBVoiJk';
    var url = SB_URL + '/rest/v1/customer_boxes?shopify_contract_id=eq.' +
      encodeURIComponent(sid) +
      (afterDateISO ? ('&delivery_date=gt.' + encodeURIComponent(afterDateISO)) : '') +
      '&order=delivery_date.asc&limit=5';
    return fetch(url, {
      headers: { apikey: SB_ANON, Authorization: 'Bearer ' + SB_ANON, Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : []; })
      .then(function (rows) {
        if (!Array.isArray(rows)) return null;
        var now = Date.now();
        for (var i = 0; i < rows.length; i++) {
          var w = computeSwapWindow(rows[i]);
          if (w && w.open && w.open.getTime() > now) return { row: rows[i], win: w };
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function loadWeeklyMenu(warehouse) {
    var wh = (warehouse || 'brisbane').toLowerCase();
    return fetch(_menuUrlFor(wh), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('menu HTTP ' + r.status); return r.json(); })
      .then(function (menu) {
        // A-Z sort on items so the step flow + portal weekly fallback
        // both render alphabetically. Swaps inside the drawer replace in
        // place, so post-swap order stays intact.
        if (menu && Array.isArray(menu.items)) {
          menu.items = menu.items.slice().sort(function (a, b) {
            return String(a && a.item_name || '').localeCompare(String(b && b.item_name || ''));
          });
        }
        return menu;
      })
      .catch(function (e) { console.error('ff-flow-data: load menu failed', e); return null; });
  }

  function init2095() {
    // Runs on two contexts now:
    //   • 2095 — full order page with veg + meat cards
    //   • any other page that renders the veg drawer (shop-now, cart UI)
    //     so the user can re-edit the box. On those pages most card-
    //     specific bindings are no-ops because the elements are absent.
    var section = document.querySelector('[data-ff-step="order"]');
    var vegDrawerEl = document.getElementById('drawer-veg');
    if (!section && !vegDrawerEl) return;

    var suburb     = lsGet('ffNewFlow.suburb');
    var household  = lsGet('ffNewFlow.household');
    var freqRaw    = lsGet('ffNewFlow.frequency');
    var recSize    = lsGet('ffNewFlow.recommendedSize') || 'S';
    var recMeatSize = lsGet('ffNewFlow.recommendedMeatSize') || recSize;
    var dietary    = lsGet('ffNewFlow.dietary') || 'none';

    var frequency = (freqRaw && typeof freqRaw === 'object') ? freqRaw.value : (freqRaw || 'weekly');

    var meatCard0 = section ? section.querySelector('[data-ff-box="meat"]') : null;
    var meatDrawer0 = document.getElementById('drawer-meat');
    var meatExcludedByDiet = dietary === 'vegetarian' || dietary === 'vegan';
    var meatRemovedByUser  = lsGet('ffNewFlow.hideMeatBox') === true;
    // Only hide when init2095 runs against the actual step-4 order page.
    // On shop-now the same init runs so drawer bindings hydrate, but the
    // user may have re-added a meat box from the "Add 100% grass fed
    // beef?" carousel — hiding #drawer-meat globally would leave the
    // cart's meat pencil silently no-oping (button adds .is-open to a
    // display:none element).
    if (section && (meatExcludedByDiet || meatRemovedByUser)) {
      if (meatCard0) meatCard0.style.display = 'none';
      if (meatDrawer0) meatDrawer0.style.display = 'none';
    }

    // ---- 1. Frequency label in greeting ----
    var freqEl = section ? section.querySelector('[data-ff-frequency-label]') : null;
    if (freqEl) { freqEl.textContent = frequency; freqEl.style.visibility = 'visible'; }

    // ---- 2. Highlight recommended size on the box card chips + drawer grid ----
    function setActiveSize(scopeEl, size) {
      if (!scopeEl) return;
      scopeEl.querySelectorAll('[data-size]').forEach(function (el) {
        el.classList.toggle('is-active', el.getAttribute('data-size') === size);
      });
    }
    var vegCard = section ? section.querySelector('.ff-box-card:not([data-ff-box="meat"])') : null;
    var meatCardEl = section ? section.querySelector('.ff-box-card[data-ff-box="meat"]') : null;
    setActiveSize(vegCard, recSize);
    setActiveSize(document.querySelector('#drawer-veg .ff-size-grid'), recSize);

    // ---- Apply box product data (title/price/image/subtitle) per size ----
    function formatMoney(cents) {
      var n = Number(cents) || 0;
      return '$' + (n / 100).toFixed(2);
    }
    var sizeLabels = { X: 'XSmall', S: 'Small', M: 'Medium', B: 'Big' };
    function _resolvePick(kind, size) {
      var data = window.__ffBoxData && window.__ffBoxData[kind];
      if (!data) return null;
      return data[size] || data.S || data.M || data.X || data.B || null;
    }
    function _familyName(kind, pick) {
      var d = window.__ffBoxData || {};
      return (kind === 'veg' ? d.vegName : d.meatName) || (pick && pick.title) || '';
    }
    // Outer-card-only update (title/image/price/sub/data attrs + active chip).
    function applyBoxData(card, kind, size) {
      var pick = _resolvePick(kind, size);
      if (!pick || !card) return;
      // Meat entries carry a per-slot sizeLabel from theme settings so the
      // client can rename e.g. "XSmall" → "Family Pack" without a code change.
      // Veg entries don't (yet) — fall back to the hardcoded size label map.
      var sizeLabel = pick.sizeLabel || sizeLabels[size] || size;
      var familyName = _familyName(kind, pick);
      var titleEl = card.querySelector('[data-ff-' + kind + '-title]');
      var priceEl = card.querySelector('[data-ff-' + kind + '-price]');
      var subEl   = card.querySelector('[data-ff-' + kind + '-sub]');
      var imgEl   = card.querySelector('.ff-box-card__media img');
      if (titleEl) titleEl.textContent = sizeLabel + ' ' + familyName;
      if (priceEl) priceEl.textContent = formatMoney(pick.price);
      if (subEl && pick.subtitle) subEl.textContent = pick.subtitle;
      if (imgEl && pick.image) { imgEl.src = pick.image; imgEl.alt = familyName; }
      // Savings row — show "Save X% compared to supermarket prices" using
      // the picked variant's price vs compareAtPrice. Hide when there's
      // no compareAtPrice (or it isn't higher than price).
      var savingsEl = card.querySelector('.ff-savings-row');
      if (savingsEl) {
        var p  = Number(pick.price) || 0;
        var cp = Number(pick.compareAtPrice) || 0;
        if (cp > p && p > 0) {
          var pct = Math.round((1 - p / cp) * 100);
          savingsEl.textContent = 'Save ' + pct + '% compared to supermarket prices';
          savingsEl.hidden = false;
          savingsEl.style.display = '';
        } else {
          savingsEl.hidden = true;
          savingsEl.style.display = 'none';
        }
      }
      card.setAttribute('data-ff-product-id', pick.id);
      card.setAttribute('data-ff-product-handle', pick.handle);
      // Drives the stepped --ff-box-img-scale in new-flow.css.
      card.setAttribute('data-ff-size', size);
    }
    // Drawer-only update (size grid active + box-head(s) image/title/price/sub
    // + meat items list for the meat drawer).
    function applyDrawerHead(kind, size) {
      var pick = _resolvePick(kind, size);
      if (!pick) return;
      var sizeLabel = pick.sizeLabel || sizeLabels[size] || size;
      var familyName = _familyName(kind, pick);
      var drawerSub = pick.people ? sizeLabel + ' · ' + pick.people : sizeLabel;
      var drawer = document.getElementById(kind === 'meat' ? 'drawer-meat' : 'drawer-veg');
      if (!drawer) return;
      // Drives the stepped --ff-drawer-img-scale in new-flow.css.
      drawer.setAttribute('data-ff-size', size);
      drawer.querySelectorAll('.ff-drawer-box-head__title').forEach(function (el) { el.textContent = sizeLabel + ' ' + familyName; });
      drawer.querySelectorAll('.ff-drawer-box-head__price').forEach(function (el) { el.textContent = formatMoney(pick.price); });
      drawer.querySelectorAll('.ff-drawer-box-head__sub').forEach(function (el) { el.textContent = drawerSub; });
      if (pick.image) {
        drawer.querySelectorAll('.ff-drawer-box-head__media img').forEach(function (im) {
          im.src = pick.image; im.alt = familyName;
        });
      }
      var grid = drawer.querySelector('.ff-size-grid');
      if (grid) {
        grid.querySelectorAll('[data-size]').forEach(function (el) {
          el.classList.toggle('is-active', el.getAttribute('data-size') === size);
        });
      }
      if (kind === 'meat') renderMeatItems(pick.meatBoxItems || [], pick.meatItemsHtml);
    }
    function renderMeatItems(items, customHtml) {
      var list = document.querySelector('[data-ff-meat-incl]');
      if (!list) return;
      list.innerHTML = '';
      // If the meat box product has a custom Rich Text override
      // (metafield custom.meat_box_items_html), render that HTML and
      // skip the structured items loop.
      if (customHtml && String(customHtml).trim()) {
        list.innerHTML = customHtml;
        return;
      }
      items.forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'ff-incl-item';
        var imgSrc = it.image || '';
        row.innerHTML =
          '<span class="ff-incl-item__icon">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="">' : '') +
          '</span>' +
          '<span class="ff-incl-item__name">' + escapeHtmlOuter(it.title || '') + '</span>' +
          '<span class="ff-incl-item__qty">' + escapeHtmlOuter(it.qty || '') + '</span>';
        list.appendChild(row);
      });
    }
    function escapeHtmlOuter(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    applyBoxData(vegCard, 'veg', recSize);
    // Meat pairing uses its own recommended size (algorithm: veg X/S → meat S,
    // veg M → meat M, veg B → meat B). Passing recSize here made meat fall
    // through _resolvePick's fallback and paint the largest available box
    // (e.g. Beef Only Box) next to XSmall veg.
    if (meatCardEl) applyBoxData(meatCardEl, 'meat', recMeatSize);

    // Exposed so external modules (e.g. new-flow.js drawer-open hook) can
    // populate the drawer head + What's included list on pages where
    // meatCardEl doesn't exist (shop-now, update-products). Without this
    // the meat drawer opens with an empty incl list until the customer
    // clicks a size chip and bindDrawerSize fires applyDrawerHead.
    window.__ffApplyDrawerHead = applyDrawerHead;

    // ---- 3. Fetch weekly menu, render items ----
    // Out-of-service postcodes are rejected at 2090, so by the time the
    // user reaches this page the suburb is always a serviced zone whose
    // warehouse_location is brisbane or melbourne.
    var warehouse = (suburb && suburb.warehouse_location) || 'brisbane';

    var inclListEl = document.querySelector('[data-ff-veg-incl]');
    var exclListEl = document.querySelector('[data-ff-excl-list]');
    var swapListEl = document.querySelector('[data-ff-swap-list]');

    // Indexes populated once the WP-cached data resolves.
    var ffProductsByFunkyId = {};   // funky_item_id (string) → { title, image, item_category }
    var ffProductsByTitleLC = {};   // lowercased title → { title, image, item_category, funky_item_id }
    var ffSuggestionsByCatLC = {};  // lowercased exclusion_name → { suggestion_1..6 }

    loadItemsMap().then(function (map) {
      if (!map) return;
      (map.products || []).forEach(function (p) {
        if (p.funky_item_id) ffProductsByFunkyId[String(p.funky_item_id)] = p;
        if (p.title) ffProductsByTitleLC[String(p.title).toLowerCase()] = p;
      });
      applySubstitutions();
    });
    loadSuggestions().then(function (data) {
      if (!data) return;
      (data.rows || []).forEach(function (r) {
        if (r.exclusion_name) ffSuggestionsByCatLC[String(r.exclusion_name).toLowerCase()] = r;
      });
      applySubstitutions();
    });

    function renderItems(items, size) {
      if (!inclListEl) return;
      var rows = items.filter(function (it) {
        var boxes = it.weekly_box_items || [];
        return boxes.some(function (b) { return b.box_size === size && Number(b.quantity) > 0; });
      });
      inclListEl.innerHTML = '';
      rows.forEach(function (it) {
        var row = document.createElement('div');
        row.className = 'ff-incl-item';
        row.setAttribute('data-orig-name', it.item_name);
        // Unique per-row key so two rows with the same item_name (e.g.
        // two Bananas produced by successive swaps) don't collide in
        // portalSwapsMap. Prefer Supabase's weekly_item_id; fall back
        // to item_name for the step flow (menu items have no per-row
        // id and each name appears only once there).
        row.setAttribute('data-orig-key', String(it.weekly_item_id || it.item_name));
        if (it.funky_item_id) row.setAttribute('data-orig-funky-id', String(it.funky_item_id));
        row.innerHTML =
          '<span class="ff-incl-item__icon"><img src="' + window.__ffPlaceholderIcon + '" alt=""></span>' +
          '<span class="ff-incl-item__name">' + escapeHtml(it.item_name) + '</span>' +
          '<button class="ff-incl-item__swap" type="button" data-swap-open ' +
          'data-swap-name="' + escapeHtml(it.item_name) + '">Swap</button>';
        inclListEl.appendChild(row);
      });
      applySubstitutions();
    }

    // Build the set of names the customer considers "excluded" — expands
    // each saved exclusion to its sameProducts synonyms (from the
    // exclude_items metaobject emitted as window.__ffExcludeItems).
    function buildExcludedSet() {
      var saved = _ffIsPortalSwap ? portalExclusions : (lsGet('ffNewFlow.exclusions') || []);
      var byName = {};
      (window.__ffExcludeItems || []).forEach(function (e) { if (e && e.name) byName[e.name] = e; });
      var set = {};
      saved.forEach(function (n) {
        set[String(n).toLowerCase()] = 1;
        var entry = byName[n];
        if (entry && entry.sameProducts) {
          String(entry.sameProducts).split(',').forEach(function (syn) {
            var s = syn.trim();
            if (s) set[s.toLowerCase()] = 1;
          });
        }
      });
      return set;
    }

    // For a given product (looked up via funky_item_id), find the first
    // suggestion that isn't itself excluded. Returns {name, funkyId, icon}
    // on success, or null. Prefers the new funky_item_ids JSON array (carries
    // both name and id, so we can look the substitute's product up directly);
    // falls back to legacy suggestion_1..6 strings (resolved by title) when
    // the new field is absent.
    function findSubstitute(funkyId, excludedSetLC) {
      if (!funkyId) return null;
      var p = ffProductsByFunkyId[String(funkyId)];
      if (!p || !p.item_category) return null;
      var row = ffSuggestionsByCatLC[String(p.item_category).toLowerCase()];
      if (!row) return null;

      // New format: funky_item_ids = [{name, funky_item_id}, ...]
      if (Array.isArray(row.funky_item_ids) && row.funky_item_ids.length) {
        for (var i = 0; i < row.funky_item_ids.length; i++) {
          var entry = row.funky_item_ids[i];
          if (!entry || !entry.funky_item_id) continue;
          var sub = ffProductsByFunkyId[String(entry.funky_item_id)];
          if (!sub) continue;
          // Check exclusion against BOTH the suggestion's name and the
          // canonical product title (they can diverge after collection edits).
          var suggName = String(entry.name || '').toLowerCase();
          var prodName = String(sub.title || '').toLowerCase();
          if (suggName && excludedSetLC[suggName]) continue;
          if (prodName && excludedSetLC[prodName]) continue;
          return { name: sub.title || entry.name, funkyId: entry.funky_item_id, icon: sub.image || null };
        }
      }

      // Legacy fallback: suggestion_1..6 plain strings — resolve via title map.
      for (var j = 1; j <= 6; j++) {
        var name = row['suggestion_' + j];
        if (!name) continue;
        if (excludedSetLC[String(name).toLowerCase()]) continue;
        var legacy = ffProductsByTitleLC[String(name).toLowerCase()];
        return {
          name: String(name),
          funkyId: legacy && legacy.funky_item_id,
          icon: legacy && legacy.image || null
        };
      }
      return null;
    }

    // applySubstitutions = render swaps + apply substitute whenever the
    // intended item (user-swapped target OR original menu item) is in the
    // current exclusion set. Idempotent — safe to call on every excl /
    // swap change. Covers all three scenarios per updated spec:
    //   1) menu has apple → excludes apple → apple becomes substitute
    //   2) swap X→apple → excludes apple → X's swap target becomes substitute
    //   3) excludes apple → swap X→apple → X becomes substitute (always worked)
    function applySubstitutions() {
      if (!inclListEl) return;
      var swaps = _ffIsPortalSwap ? portalSwapsMap : (lsGet('ffNewFlow.swaps') || {});
      var excludedSet = buildExcludedSet();
      inclListEl.querySelectorAll('.ff-incl-item').forEach(function (row) {
        var origName = row.getAttribute('data-orig-name') || '';
        var origKey = row.getAttribute('data-orig-key') || origName;
        var origFunkyId = row.getAttribute('data-orig-funky-id') || '';

        // Resolve the "intended" item: user swap target takes precedence,
        // otherwise the menu's original.
        var swapEntry = swaps[origKey];
        var swapTo = (swapEntry && typeof swapEntry === 'object') ? swapEntry.name : swapEntry;
        var swapIcon = (swapEntry && typeof swapEntry === 'object') ? swapEntry.icon : null;
        var swapFunkyId = (swapEntry && typeof swapEntry === 'object') ? swapEntry.funkyId : null;
        var swapExplicit = (swapEntry && typeof swapEntry === 'object') ? !!swapEntry.swapped : false;
        var hasUserSwap = !!swapEntry && (swapExplicit || (!!swapTo && swapTo !== origName));

        var intendedName = swapTo || origName;
        var intendedIcon = swapIcon || null;
        var intendedFunkyId = swapFunkyId || origFunkyId;

        // Substitute when intended is in the excluded set. Strip any prior
        // "(substitute)" suffix before the check so re-renders are idempotent.
        var substituted = false;
        var intendedBare = String(intendedName).replace(/\s*\(substitute\)\s*$/i, '');
        var intendedLC = intendedBare.toLowerCase();
        if (intendedLC && excludedSet[intendedLC]) {
          var sub = findSubstitute(intendedFunkyId, excludedSet);
          if (sub && sub.name) {
            intendedName = sub.name + ' (substitute)';
            if (sub.funkyId) intendedFunkyId = sub.funkyId;
            if (sub.icon) intendedIcon = sub.icon;
            substituted = true;
          }
        }

        // Image fallback if neither swap pick nor substitute supplied an icon.
        if (!intendedIcon) {
          var baseProduct = null;
          if (intendedFunkyId) baseProduct = ffProductsByFunkyId[String(intendedFunkyId)];
          if (!baseProduct && intendedName) {
            var lookupLC = String(intendedName).replace(/\s*\(substitute\)\s*$/i, '').toLowerCase();
            baseProduct = ffProductsByTitleLC[lookupLC];
          }
          if (baseProduct && baseProduct.image) intendedIcon = baseProduct.image;
        }

        var nameEl = row.querySelector('.ff-incl-item__name');
        if (nameEl) nameEl.textContent = intendedName;
        var imgEl = row.querySelector('.ff-incl-item__icon img');
        if (imgEl && intendedIcon) imgEl.src = intendedIcon;
        row.classList.toggle('is-swapped', hasUserSwap);
        row.classList.toggle('is-substituted', substituted);
      });
      // Box contents changed — refresh which swap candidates are at their cap.
      updateSwapModalAvailability();
    }

    // Max copies of one product the box may hold via swapping. Once a product
    // reaches this count in the veg incl list it is hidden from the swap modal
    // so it can't be added again; it reappears when the count drops below CAP.
    var SWAP_PRODUCT_CAP = 5;

    // Count how many incl rows currently show each product (case-insensitive,
    // ignoring any "(substitute)" suffix so the visible produce is counted).
    function countBoxProducts() {
      var counts = {};
      if (!inclListEl) return counts;
      inclListEl.querySelectorAll('.ff-incl-item__name').forEach(function (el) {
        var name = String(el.textContent || '')
          .replace(/\s*\(substitute\)\s*$/i, '')
          .trim()
          .toLowerCase();
        if (name) counts[name] = (counts[name] || 0) + 1;
      });
      return counts;
    }

    // Hide swap-modal candidate rows for products already at the box cap
    // OR whose custom.is_swappable_{size} metafield excludes the drawer's
    // currently-selected box size.
    function updateSwapModalAvailability() {
      var listEl = document.querySelector('[data-ff-swap-list]');
      if (!listEl) return;
      var counts = countBoxProducts();
      // Current drawer size (veg first — meat drawer would need its own read).
      var activeSizeEl = document.querySelector('#drawer-veg .ff-size-grid [data-size].is-active');
      var currentSize = activeSizeEl ? String(activeSizeEl.getAttribute('data-size') || '').toUpperCase() : '';
      listEl.querySelectorAll('.ff-swap-modal__row').forEach(function (rowBtn) {
        var name = String(rowBtn.getAttribute('data-swap-name') || '').trim().toLowerCase();
        var atCap = !!name && (counts[name] || 0) >= SWAP_PRODUCT_CAP;
        var sizesAttr = rowBtn.getAttribute('data-swap-sizes') || '';
        var sizesList = sizesAttr ? sizesAttr.split(',') : [];
        // If we know the current size AND the row declares any sizes, hide
        // when the row's size list doesn't include it. Rows with no
        // metafield data (missing from __ffSwapMeta) stay visible so the
        // filter is opt-in — only products that have set at least one
        // is_swappable_* flag are subject to the exclusion.
        var wrongSize = currentSize && sizesList.length && sizesList.indexOf(currentSize) === -1;
        var hide = atCap || wrongSize;
        rowBtn.style.display = hide ? 'none' : '';
        rowBtn.setAttribute('aria-hidden', hide ? 'true' : 'false');
      });
    }

    // Must be declared before renderExclusions() runs (line below) — otherwise
    // the initial enforceExclLimit() call sees EXCL_MAX === undefined and
    // `length >= undefined` is always false, so a page that loads with 10
    // already-saved exclusions never locks the remaining rows until the user
    // toggles a checkbox (which re-runs enforce after EXCL_MAX is finally set).
    var EXCL_MAX = 10;

    function renderExclusions() {
      if (!exclListEl) return;
      // Source is the metaobject-backed full set rendered into the page
      // by Liquid (window.__ffExcludeItems) — matches legacy behaviour,
      // not just this week's menu items.
      var fullSet = (window.__ffExcludeItems || []).slice();
      var checkedSource = _ffIsPortalSwap ? portalExclusions : (lsGet('ffNewFlow.exclusions') || []);
      // Keep saved names missing from today's catalogue selectable/removable.
      checkedSource.forEach(function(name){if(!fullSet.some(function(entry){return entry && entry.name===name;}))fullSet.push({name:name,sameProducts:name});});
      exclListEl.innerHTML = '';
      fullSet.forEach(function (entry) {
        var name = entry && entry.name;
        if (!name) return;
        var label = document.createElement('label');
        label.className = 'ff-excl-row';
        // Carry the synonym list onto the row so cart-side matching can
        // expand from a checked entry to its equivalents (same shape as
        // the legacy `data-same-products` attribute).
        label.setAttribute('data-same-products', entry.sameProducts || name);
        var isChecked = checkedSource.indexOf(name) !== -1;
        label.innerHTML =
          '<input type="checkbox" value="' + escapeHtml(name) + '"' + (isChecked ? ' checked' : '') + '>' +
          '<span class="ff-excl-row__name">' + escapeHtml(name) + '</span>';
        exclListEl.appendChild(label);
      });
      enforceExclLimit(checkedSource);
      renderExclChips(checkedSource);
    }
    // Populate the full-set checkbox list immediately on init (independent
    // of the weekly menu fetch). Skip on portal-swap pages — _ffIsPortalSwap
    // is set below via `var` hoisting and reads as undefined here, so the
    // initial render would fall into the else-branch and paint stale
    // localStorage.ffNewFlow.exclusions (step-flow leftovers). Portal-swap
    // pages wait for the Supabase resolve to render with the real data.
    var _initIsPortalSwap = !!(new URLSearchParams(window.location.search).get('subscriptionId'))
      && !!window.__customerBoxPromise;
    if (!_initIsPortalSwap) renderExclusions();

    var exclChipsEl = document.querySelector('[data-excl-chips]');

    function getCheckedExcl() {
      if (!exclListEl) return [];
      return Array.prototype.slice
        .call(exclListEl.querySelectorAll('input[type="checkbox"]:checked'))
        .map(function (cb) { return cb.value; });
    }

    function enforceExclLimit(checked) {
      if (!exclListEl) return;
      var atLimit = checked.length >= EXCL_MAX;
      exclListEl.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        cb.disabled = atLimit && !cb.checked;
      });
    }

    function getCheckedExcl() {
      if (!exclListEl) return [];
      return Array.prototype.slice
        .call(exclListEl.querySelectorAll('input[type="checkbox"]:checked'))
        .map(function (cb) { return cb.value; });
    }

    function commitExclusions() {
      var checked = getCheckedExcl();
      enforceExclLimit(checked);
      renderExclChips(checked);
      if (_ffIsPortalSwap) {
        portalExclusions = checked;
      } else {
        lsSet('ffNewFlow.exclusions', checked);
      }
      applySubstitutions();
      if (_ffIsPortalSwap) syncPortalRescueAndCart();
      // Step flow: drawer's Excluding change must also reach localCart +
      // cart-modal immediately. Use the same function the post-step-3 flow
      // uses (defined in cart-modal-slider.liquid; matches the veg box in
      // localCart by product_ids_string). Without this, the cart shows
      // stale Excluding until refresh — refresh works because
      // loadInitialValuesOfBlackList re-reads from the localCart row that
      // updateLocalStorageBoxItems writes.
      else {
        // Step flow: drawer's Excluding change must reach (1) localCart
        // properties so a refresh still shows the new value, AND (2) the
        // already-rendered cart-modal DOM rows so the user sees the change
        // without a refresh. updateCartUI(null, true) doesn't re-render
        // the Excluding row, so we patch the DOM directly here (same
        // pattern syncPortalRescueAndCart uses for portal-swap mode).
        try {
          var sizeMapEx = (window.__ffBoxData && window.__ffBoxData.veg) || {};
          var vegVidsEx = {};
          var vegPidsEx = {};
          Object.keys(sizeMapEx).forEach(function (k) {
            var entry = sizeMapEx[k];
            if (!entry) return;
            if (entry.variantId) vegVidsEx[String(entry.variantId)] = 1;
            if (entry.id) vegPidsEx[String(entry.id)] = 1;
          });
          var newExclStr = (checked && checked.length) ? checked.join(', ') : '';

          // (1) Update localCart properties on the veg box entry.
          var lcRawEx = localStorage.getItem('localCart');
          var lcEx = lcRawEx ? JSON.parse(lcRawEx) : [];
          if (Array.isArray(lcEx)) {
            var changedEx = false;
            lcEx.forEach(function (it) {
              if (!it) return;
              var vid = it.variantId || it.id;
              var pid = it.productId;
              var isVeg = (vid && vegVidsEx[String(vid)])
                       || (pid && vegPidsEx[String(pid)]);
              if (!isVeg) return;
              if (!it.properties) it.properties = {};
              var prev = it.properties.Excluding || '';
              if (prev === newExclStr) return;
              if (newExclStr) it.properties.Excluding = newExclStr;
              else delete it.properties.Excluding;
              changedEx = true;
            });
            if (changedEx) localStorage.setItem('localCart', JSON.stringify(lcEx));
          }

          // (2) Patch the visible cart-modal rows in place. Match every
          // <tr id="CartItem-{variantId}-..."> whose variantId is a veg
          // box variant, find/create the Excluding .list div and rewrite
          // its content.
          document.querySelectorAll('tr[id^="CartItem-"]').forEach(function (row) {
            var m = row.id.match(/^CartItem-(\d+)-/);
            if (!m || !vegVidsEx[m[1]]) return;
            var lists = row.querySelector('.cart-product--list-info .lists');
            if (!lists && row.nextElementSibling) {
              lists = row.nextElementSibling.querySelector('.cart-product--list-info .lists');
            }
            if (!lists) return;
            var existing = null;
            Array.prototype.slice.call(lists.querySelectorAll('.list')).some(function (l) {
              if (/^Excluding:/.test((l.textContent || '').trim())) { existing = l; return true; }
              return false;
            });
            // Excluding line intentionally suppressed per 2026-07-08 spec
            // (matches appendTableFunction's veg-box droprow render).
            // Only ensure any lingering row is stripped — never re-append.
            if (existing) existing.parentNode.removeChild(existing);
          });
        } catch (e) { console.error('ff-flow-data: Excluding sync to cart failed', e); }
      }
    }

    function renderExclChips(names) {
      if (!exclChipsEl) return;
      exclChipsEl.innerHTML = '';
      names.forEach(function (name) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ff-excl-chip';
        btn.setAttribute('data-excl-name', name);
        btn.innerHTML =
          '<span>' + escapeHtml(name) + '</span>' +
          '<span class="ff-excl-chip__close" aria-hidden="true">' +
          '<svg width="9" height="9" viewBox="0 0 9 9" fill="none">' +
          '<path d="M7.51321 1.54593L0.913547 8.14559M0.913547 1.54593L7.51321 8.14559" stroke="#1B1C1E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg></span>';
        btn.addEventListener('click', function () {
          if (exclListEl) {
            var cb = exclListEl.querySelector('input[type="checkbox"][value="' + name.replace(/"/g, '\\"') + '"]');
            if (cb) cb.checked = false;
          }
          commitExclusions();
        });
        exclChipsEl.appendChild(btn);
      });
    }

    if (exclListEl) {
      exclListEl.addEventListener('change', function (e) {
        var cb = e.target;
        if (!cb || cb.type !== 'checkbox') return;
        if (cb.checked && getCheckedExcl().length > EXCL_MAX) {
          cb.checked = false;
          return;
        }
        commitExclusions();
      });
    }
    // Initial chip row reflects the saved exclusions even before menu loads.
    renderExclChips(_ffIsPortalSwap ? portalExclusions : (lsGet('ffNewFlow.exclusions') || []));

    // Swap candidate list — sourced from window.__ffSwapItems, emitted by
    // ff-veg-drawer.liquid using the swap-box-items collection. Rendered
    // once (collection is small, ~30 products); no /products.json fetch
    // means no Shopify CDN cache lag when the collection changes.
    function appendSwapRows(items) {
      if (!swapListEl) return;
      items.forEach(function (p) {
        var name = (p.title || '').trim();
        if (!name) return;
        var img = p.image || '';
        var btn = document.createElement('button');
        btn.className = 'ff-swap-modal__row';
        btn.type = 'button';
        btn.setAttribute('data-swap-name', name);
        if (img) btn.setAttribute('data-swap-icon', img);
        // Sizes this candidate applies to (from custom.is_swappable_* metafields).
        // Comma-joined list like "S,M,B" — updateSwapModalAvailability
        // filters rows whose list doesn't include the drawer's current size.
        if (p.sizes) btn.setAttribute('data-swap-sizes', p.sizes);
        btn.innerHTML =
          '<span class="ff-swap-modal__row-icon">' +
          (img ? '<img src="' + img + '" alt="">' : '') +
          '</span>' +
          '<span class="ff-swap-modal__row-name">' + escapeHtml(name) + '</span>' +
          '<span class="ff-swap-modal__select">Select</span>';
        swapListEl.appendChild(btn);
      });
      // Newly rendered candidates must respect the box cap + size filter.
      updateSwapModalAvailability();
    }

    if (swapListEl) {
      if (!swapListEl.style.overflowY) swapListEl.style.overflowY = 'auto';
      appendSwapRows(window.__ffSwapItems || []);
      // The Liquid-rendered __ffSwapItems is baked into the HTML page and
      // browsers cache the page for hours. Hit the Storefront GraphQL API
      // for realtime collection membership + per-product is_swappable_*
      // metafields (no CDN cache on this endpoint), then rebuild the modal
      // rows so admin edits show up on the next page load without waiting
      // for HTML/JSON caches to expire.
      (function refreshSwapItemsFromStorefront() {
        var SF_TOKEN = '4c852d69a30bcc65206b96a09669637e';
        var SF_URL = '/api/2024-10/graphql.json';
        var query = 'query{collection(handle:"swap-box-items"){products(first:250){nodes{handle title featuredImage{url(transform:{maxWidth:96})} x:metafield(namespace:"custom",key:"is_swappable_x"){value} s:metafield(namespace:"custom",key:"is_swappable_s"){value} m:metafield(namespace:"custom",key:"is_swappable_m"){value} b:metafield(namespace:"custom",key:"is_swappable_b"){value}}}}}';
        fetch(SF_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': SF_TOKEN,
            'Accept': 'application/json'
          },
          body: JSON.stringify({ query: query }),
          cache: 'no-store'
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (payload) {
            var nodes = payload && payload.data && payload.data.collection && payload.data.collection.products && payload.data.collection.products.nodes;
            if (!Array.isArray(nodes)) return;
            var fresh = nodes.map(function (n) {
              var sizes = '';
              if (n.x && n.x.value === 'true') sizes += 'X,';
              if (n.s && n.s.value === 'true') sizes += 'S,';
              if (n.m && n.m.value === 'true') sizes += 'M,';
              if (n.b && n.b.value === 'true') sizes += 'B,';
              sizes = sizes.replace(/,$/, '');
              return {
                handle: n.handle,
                title: n.title,
                image: (n.featuredImage && n.featuredImage.url) || '',
                sizes: sizes
              };
            });
            window.__ffSwapItems = fresh;
            // Rebuild rows from scratch so both membership and metafield
            // changes propagate (e.g. is_swappable_s toggled off).
            while (swapListEl.firstChild) swapListEl.removeChild(swapListEl.firstChild);
            appendSwapRows(fresh);
          })
          .catch(function () { /* realtime refresh is best-effort */ });
      })();
    }

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // Veg + meat have independent size states.
    var sizes = lsGet('ffNewFlow.boxSizes') || {};
    var vegSize = sizes.veg || lsGet('ffNewFlow.chosenSize') || recSize;
    var meatSize = sizes.meat || lsGet('ffNewFlow.chosenSize') || recMeatSize;
    var currentItems = [];

    // portalSwapsMap mirrors `ffNewFlow.swaps` shape but is sourced from
    // customer_boxes.final_items[].swap_source. Populated in the portal
    // branch below and read by applySubstitutions. Empty in step flow.
    var portalSwapsMap = {};
    // portalExclusions mirrors `ffNewFlow.exclusions` shape (array of
    // names) but is sourced from customer_boxes.exclusions_applied[].
    // item_name. Read by renderExclusions / buildExcludedSet /
    // renderExclChips when _ffIsPortalSwap is true. Empty in step flow.
    var portalExclusions = [];
    var exclusionsQuery = new URLSearchParams(window.location.search);
    if (exclusionsQuery.get('subscriptionId') && window.FFSubscriptionPreferences) {
      if (exclListEl) exclListEl.inert = true;
      window.__ffSubscriptionExclusionsReady = window.FFSubscriptionPreferences.load(exclusionsQuery.get('token'),exclusionsQuery.get('subscriptionId')).then(function(contract){
        portalExclusions = window.FFSubscriptionPreferences.read(contract);
        lsSet('ffNewFlow.exclusions',portalExclusions);
        renderExclusions();
        renderExclChips(portalExclusions);
        if (exclListEl) exclListEl.inert = false;
        if (_ffIsPortalSwap) syncPortalRescueAndCartSoon();
        return portalExclusions;
      });
      window.__ffSubscriptionExclusionsReady.catch(function(error){
        console.error('Subscription exclusions load failed',error.message);
        if (exclListEl) exclListEl.innerHTML = '<p>Unable to load exclusions. Please reload before editing.</p>';
      });
    }

    // The size baked into the customer's customer_boxes row — final_items
    // is only meaningful for THIS size. Other sizes fall through to the
    // weekly_menu defaults (portalWeeklyItems), so size-switching in the
    // drawer shows the right default list per spec.
    var portalCustomerSize = null;
    var portalCustomerItems = [];   // final_items mapped to renderItems shape
    var portalWeeklyItems = [];     // weekly_menu items for the customer's warehouse
    var portalCurrentBoxId = null;  // customer_boxes row uuid — set on init, used on commit
    var _swapWindowBoxAL = null;    // cached Supabase row (allowlist) so commit can recompute swap window
    var portalBaseFinalItems = [];  // raw box.final_items as received from Supabase (for diff/passthrough)

    // Portal Swap A: on /collections/update-products the box-items list
    // is the customer's curated next-delivery final_items from Supabase
    // (customer_boxes), not the weekly menu. customer-box-preload
    // .liquid kicks the fetch during HTML parse and exposes the row on
    // window.__customerBoxPromise. We project final_items into the same
    // shape renderItems expects (weekly_box_items synthesised so the
    // box-size filter passes), so the same render path keeps working.
    var _ffPSQs = new URLSearchParams(window.location.search);
    var _ffIsPortalSwap = !!_ffPSQs.get('subscriptionId')
      && !!window.__customerBoxPromise
      && document.documentElement.classList.contains('ff-portal-swap-enabled');

    if (_ffIsPortalSwap) {
      // Cart-driven size sync runs OUTSIDE the Supabase resolve so the
      // drawer + outer card track the subscription regardless of whether
      // customer_boxes has a row for this delivery. Cart is the source of
      // truth (the cart-modal and rescue-box card already render from it).
      (function () {
        var vegSizeMapInd = (window.__ffBoxData && window.__ffBoxData.veg) || {};
        var vidToSizeInd = {};
        Object.keys(vegSizeMapInd).forEach(function (k) {
          var v = vegSizeMapInd[k] && (vegSizeMapInd[k].variantId || vegSizeMapInd[k].id);
          if (v) vidToSizeInd[String(v)] = k;
        });
        function findSizeFromCartInd() {
          try {
            var lcRaw = localStorage.getItem('localCart');
            var lc = lcRaw ? JSON.parse(lcRaw) : [];
            if (!Array.isArray(lc)) return null;
            for (var li = 0; li < lc.length; li++) {
              var lit = lc[li];
              var lvid = lit && (lit.variantId || lit.id);
              if (lvid && vidToSizeInd[String(lvid)]) return vidToSizeInd[String(lvid)];
            }
          } catch (e) {}
          return null;
        }
        function applySizeOverride(s) {
          if (!s || s === vegSize) return false;
          vegSize = s;
          portalCustomerSize = s;
          setActiveSize(vegCard, s);
          setActiveSize(document.querySelector('#drawer-veg .ff-size-grid'), s);
          applyBoxData(vegCard, 'veg', s);
          applyDrawerHead('veg', s);
          if (Array.isArray(portalCustomerItems) && portalCustomerItems.length) {
            currentItems = portalCustomerItems;
            renderItems(currentItems, s);
          }
          if (typeof syncPortalRescueAndCart === 'function') syncPortalRescueAndCart();
          return true;
        }
        // Try immediately, then poll for up to 20s while Appstle fetches.
        if (!applySizeOverride(findSizeFromCartInd())) {
          var _r = 0, _max = 80;
          var t = setInterval(function () {
            _r++;
            var s = findSizeFromCartInd();
            if (s) { applySizeOverride(s); clearInterval(t); }
            else if (_r >= _max) clearInterval(t);
          }, 250);
        }
      })();

      // Swap-window gate: apply ff-swap-open / ff-swap-locked on <html> and
      // fill in the drawer's locked-state Editing-starts / Edit-until-billing
      // dates from the current box (when locked, fall back to the next box's
      // window).
      function _formatBrisWeekdayDay(d) {
        // d = Date object representing a UTC instant. Convert to Brisbane wall
        // clock (UTC+10), then format as e.g. "Wed 18 Jun".
        var bris = new Date(d.getTime() + 10 * 3600000);
        var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        return days[bris.getUTCDay()] + ' ' + bris.getUTCDate() + ' ' + months[bris.getUTCMonth()];
      }
      function _fillLockedDates(win) {
        if (!win || !win.open || !win.close) return;
        var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        function fmtLong(d) {
          var b = new Date(d.getTime() + 10 * 3600000);
          return days[b.getUTCDay()] + ' ' + b.getUTCDate() + ' ' + months[b.getUTCMonth()];
        }
        function fmtShort(d) {
          var b = new Date(d.getTime() + 10 * 3600000);
          return days[b.getUTCDay()];
        }
        // Two render targets with different copy:
        //   • .swap-open-pop-up in ff-veg-drawer — h2 reads "Swaps Open <Wed 4pm>";
        //     just weekday + hour (no date number) to match deploy theme.
        //   • .ff-rescue-locked-block on the rescue card —
        //     "Editing starts: <Wed 24 Jun 4pm>" + "Edit until billing: <Sat 28 Jun 6am>".
        // Swap-open overlay shows full "Tue 24 Jun 4pm" (was just "Tue 4pm")
        // per updated spec — keeps it consistent with the rescue card.
        var startShort = fmtLong(win.open) + ' ' + formatLockedTime(win.openHour, win.openMinute);
        var startLong  = fmtLong(win.open)  + ' ' + formatLockedTime(win.openHour, win.openMinute);
        var billingLong = fmtLong(win.close) + ' 8pm';
        document.querySelectorAll('.swap-open-pop-up [data-ff-locked-edit-start]').forEach(function (el) {
          el.textContent = startShort;
        });
        document.querySelectorAll('.ff-rescue-locked-block [data-ff-locked-edit-start]').forEach(function (el) {
          el.textContent = startLong;
        });
        document.querySelectorAll('.ff-rescue-locked-block [data-ff-locked-edit-billing]').forEach(function (el) {
          el.textContent = billingLong;
        });
        // Cart-modal droprow also carries the locked block (CSS-hidden by
        // default, revealed by html.ff-swap-locked). Fill its dates too.
        document.querySelectorAll('.ff-cart-locked-block [data-ff-locked-edit-start]').forEach(function (el) {
          el.textContent = startLong;
        });
        document.querySelectorAll('.ff-cart-locked-block [data-ff-locked-edit-billing]').forEach(function (el) {
          el.textContent = billingLong;
        });
      }
      // Compute swap window straight from Appstle subscription data
      // (next_billing_date + delivery zone). Independent of the Supabase
      // customer_boxes row generation cycle, so it stays accurate even
       // in the gap between window-close and next-row-gen. Returns null
      // when prerequisite data isn't loaded yet.
      function _readAppstleBillingAddr() {
        try {
          var lc = JSON.parse(localStorage.getItem('localCart') || 'null');
          var billingISO = lc && lc[0] && lc[0].nextBillingDate;
          var addr = lc && lc[0] && lc[0].deliveryAddress;
          if (!billingISO || !addr) {
            var raw = JSON.parse(localStorage.getItem('currentSubscription') || 'null');
            billingISO = billingISO || (raw && raw.nextBillingDate);
            addr = addr || (raw && raw.deliveryMethod && raw.deliveryMethod.address);
          }
          if (billingISO && addr) return { billingISO: billingISO, addr: addr };
        } catch (e) {}
        return null;
      }
      function computeWindowFromAppstle() {
        // Wait for Appstle bootstrap to populate localCart (up to 15s).
        var ready = _readAppstleBillingAddr();
        var waitForData = ready
          ? Promise.resolve(ready)
          : new Promise(function (resolve) {
              var tries = 0;
              var t = setInterval(function () {
                tries++;
                var r = _readAppstleBillingAddr();
                if (r) { clearInterval(t); resolve(r); }
                else if (tries >= 60) { clearInterval(t); resolve(null); }
              }, 250);
            });
        return waitForData.then(function (data) {
          if (!data) return null;
          var billingISO = data.billingISO;
          var addr = data.addr;
          if (typeof findZoneData !== 'function') return null;
          return Promise.resolve(findZoneData(addr.city, addr.provinceCode, addr.zip))
            .then(function (zone) {
              if (!zone || !zone.day) return null;
              var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
              var targetDow = -1;
              for (var i = 0; i < dayNames.length; i++) {
                if (String(zone.day).indexOf(dayNames[i]) !== -1) { targetDow = i; break; }
              }
              if (targetDow === -1) return null;
              var b = new Date(billingISO);
              var d = new Date(b.getTime());
              for (var step = 1; step <= 14; step++) {
                d.setUTCDate(d.getUTCDate() + 1);
                if (d.getUTCDay() === targetDow) break;
              }
              var pad = function (n) { return String(n).padStart(2, '0'); };
              var billingYMD = b.getUTCFullYear() + '-' + pad(b.getUTCMonth()+1) + '-' + pad(b.getUTCDate());
              var deliveryYMD = d.getUTCFullYear() + '-' + pad(d.getUTCMonth()+1) + '-' + pad(d.getUTCDate());
              return computeSwapWindow({ delivery_date: deliveryYMD, billing_date: billingYMD });
            })
            .catch(function () { return null; });
        });
      }

      // Fresh-from-Appstle window computation. Bypasses
      // localStorage.currentSubscription (which can carry a stale
      // nextBillingDate from a previous session). Uses the same
      // /apps/subscriptions/cp/api/... endpoint the close-date fix
      // below uses so both open and close are consistent + current.
      function _fetchFreshAppstleWindow(currentBoxUnused) {
        var qs = new URLSearchParams(window.location.search);
        var token = qs.get('token');
        var sid = qs.get('subscriptionId');
        if (!token || !sid) return computeWindowFromAppstle().catch(function () { return null; });
        var url = 'https://funkyfood.com.au/apps/subscriptions/cp/api'
          + '/subscription-contracts/contract-external/' + encodeURIComponent(sid)
          + '?isExternal=true&token=' + encodeURIComponent(token);
        return fetch(url, { headers: { 'Content-Type': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (result) {
            var billingISO = result && result.nextBillingDate;
            var addr = result && result.deliveryMethod && result.deliveryMethod.address;
            if (!billingISO || !addr) return null;
            if (typeof findZoneData !== 'function') return null;
            return Promise.resolve(findZoneData(addr.city, addr.provinceCode, addr.zip))
              .then(function (zone) {
                if (!zone || !zone.day) return null;
                var dayNames = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
                var targetDow = -1;
                for (var i = 0; i < dayNames.length; i++) {
                  if (String(zone.day).indexOf(dayNames[i]) !== -1) { targetDow = i; break; }
                }
                if (targetDow === -1) return null;
                var b = new Date(billingISO);
                var d = new Date(b.getTime());
                for (var step = 1; step <= 14; step++) {
                  d.setUTCDate(d.getUTCDate() + 1);
                  if (d.getUTCDay() === targetDow) break;
                }
                var pad = function (n) { return String(n).padStart(2, '0'); };
                var billingYMD = b.getUTCFullYear() + '-' + pad(b.getUTCMonth()+1) + '-' + pad(b.getUTCDate());
                var deliveryYMD = d.getUTCFullYear() + '-' + pad(d.getUTCMonth()+1) + '-' + pad(d.getUTCDate());
                return computeSwapWindow({ delivery_date: deliveryYMD, billing_date: billingYMD });
              });
          })
          .catch(function () { return null; });
      }

      function applySwapWindowState(currentBox) {
        // State classes live on <html> (not <body> — body's class gets
        // rewritten by other scripts on this page, see allowlist gate).
        var root = document.documentElement;
        // Window rules:
        //   • Start: Supabase customer_boxes.delivery_date minus 6 days
        //     (Tue delivery → 4pm; other days → 12:01am)
        //   • End: Appstle subscription nextBillingDate day @ 20:00 Brisbane
        // End date is fetched fresh from Appstle every time — never read
        // from localCart / sessionStorage / any cache. This page must
        // reflect the subscription's live billing state.
        function paint(finalWin) {
          var isOpen = isInSwapWindow(finalWin);
          root.classList.toggle('ff-swap-open', isOpen);
          root.classList.toggle('ff-swap-locked', !isOpen);
          window.__ffLastDisplayedWin = finalWin;
          window.__ffFillLockedDates = _fillLockedDates;
          if (finalWin) _fillLockedDates(finalWin);
        }
        var baseWin = currentBox ? computeSwapWindow(currentBox) : null;
        if (!baseWin) {
          // No customer_boxes row → fall back to Appstle's fresh API
          // (same endpoint the close-date fetch below uses). Skip the
          // localStorage-based computeWindowFromAppstle() first pass —
          // localStorage.currentSubscription can be stale from a
          // previous session, which would compute the window off the
          // last-cycle billingDate and show the customer a wrong open
          // date. Always go straight to the fresh Appstle fetch.
          _fetchFreshAppstleWindow(currentBox).then(paint);
          return;
        }
        var qs = new URLSearchParams(window.location.search);
        var token = qs.get('token');
        var sid = qs.get('subscriptionId');
        if (!token || !sid) { paint(baseWin); return; }
        var url = 'https://funkyfood.com.au/apps/subscriptions/cp/api'
          + '/subscription-contracts/contract-external/' + encodeURIComponent(sid)
          + '?isExternal=true&token=' + encodeURIComponent(token);
        fetch(url, { headers: { 'Content-Type': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (result) {
            try {
              var iso = result && result.nextBillingDate;
              if (iso) {
                var brisMs = new Date(iso).getTime() + 10 * 3600000;
                var brisDate = new Date(brisMs);
                var pad = function (n) { return String(n).padStart(2, '0'); };
                var ymd = brisDate.getUTCFullYear() + '-' +
                          pad(brisDate.getUTCMonth() + 1) + '-' +
                          pad(brisDate.getUTCDate());
                // Three scenarios to distinguish based on how Appstle's
                // nextBillingDate relates to this cycle's delivery_date:
                //   1. ymd <= deliveryYMD — backend postponed this cycle's
                //      billing forward. Use Appstle as close.
                //   2. ymd > deliveryYMD — this cycle already billed and
                //      Appstle's nextBillingDate points to the FOLLOWING
                //      cycle. The Supabase row we have is now stale for
                //      swap-window purposes: its window has passed.
                //      Discard it and project a fresh window from
                //      Appstle's next billing + zone data via
                //      _fetchFreshAppstleWindow, so the UI shows the
                //      NEXT cycle's editing dates instead of the past one.
                //   3. no ymd — network failure; keep Supabase-derived
                //      close as-is.
                var deliveryYMD = currentBox && currentBox.delivery_date;
                if (deliveryYMD && ymd <= deliveryYMD) {
                  var newClose = _toBrisbaneDate(ymd, 20);
                  if (newClose) baseWin.close = newClose;
                  paint(baseWin);
                  return;
                }
                if (deliveryYMD && ymd > deliveryYMD) {
                  _fetchFreshAppstleWindow(currentBox).then(function (proj) {
                    paint(proj || baseWin);
                  });
                  return;
                }
              }
            } catch (e) {}
            paint(baseWin);
          })
          .catch(function () { paint(baseWin); });
      }

      // Portal Swap A3: commit current portal state back to
      // customer_boxes. Computes new final_items by applying the
      // session's portalSwapsMap to portalBaseFinalItems (preserves
      // every field of unchanged rows), and writes the current
      // portalExclusions array. Called from cart-modal-slider's
      // updateSubscription() right before the Cloudflare Worker fires
      // the Appstle update.
      var SB_URL_W  = 'https://eaagqdyrbdlahjzdppdk.supabase.co';
      var SB_ANON_W = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVhYWdxZHlyYmRsYWhqemRwcGRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc1OTk3NDEsImV4cCI6MjA4MzE3NTc0MX0.tnteB3igOKfgXKGTDEfRiq7TcxZIKLe3wSufhBVoiJk';
      function commitPortalSwapToSupabase() {
        if (!_ffIsPortalSwap || !portalCurrentBoxId) return Promise.resolve(null);
        // Gate on the cycle's swap window. Prefer the window the UI
        // actually painted (__ffLastDisplayedWin) — that one merges
        // Appstle's live nextBillingDate, so it stays correct when
        // the backend manually postpones a cycle whose Supabase
        // billing_date is now stale. Only fall back to re-computing
        // from _swapWindowBoxAL if the displayed window is missing.
        var _gateWin = window.__ffLastDisplayedWin ||
                       computeSwapWindow(_swapWindowBoxAL);
        if (!isInSwapWindow(_gateWin)) {
          return Promise.resolve(null);
        }
        // Build new final_items per updated swap_source spec:
        //   • substitute applied (intended was in exclusion set)
        //     → swap_source = 'exclusion_rotation' (matches historical
        //        Supabase semantics for "(substitute)" rows)
        //   • user-swap only (intended not excluded)
        //     → swap_source = 'customer_swap'
        //   • neither → no change to the base item.
        // Substitute > user-swap precedence per spec.
        var swaps = portalSwapsMap || {};
        var excludedSetForCommit = buildExcludedSet();
        var newFinalItems = (portalBaseFinalItems || []).map(function (it) {
          // Key by weekly_item_id (per-row unique) so two rows with the
          // same item_name each carry their own swap. Falls back to
          // item_name for rows that pre-date weekly_item_id tracking.
          var swKey = (it && (it.weekly_item_id || it.item_name)) || '';
          var sw = swaps[swKey];
          var hasUserSwap = !!(sw && sw.swapped && sw.name && sw.name !== it.item_name);
          var intendedName = hasUserSwap ? sw.name : it.item_name;
          var intendedFunkyId = (sw && sw.funkyId) || it.funky_item_id;
          var intendedBare = String(intendedName).replace(/\s*\(substitute\)\s*$/i, '');
          var intendedLC = intendedBare.toLowerCase();
          var substituted = false;
          var finalName = intendedName;
          var finalFunkyId = intendedFunkyId;
          if (intendedLC && excludedSetForCommit[intendedLC]) {
            var subResult = findSubstitute(intendedFunkyId, excludedSetForCommit);
            if (subResult && subResult.name) {
              finalName = subResult.name + ' (substitute)';
              if (subResult.funkyId) finalFunkyId = subResult.funkyId;
              substituted = true;
            }
          }
          if (!hasUserSwap && !substituted) return it;
          var copy = Object.assign({}, it, { item_name: finalName });
          if (finalFunkyId) copy.funky_item_id = finalFunkyId;
          copy.swap_source = substituted ? 'exclusion_rotation' : 'customer_swap';
          return copy;
        });
        // Build swaps_applied log — one entry per actually-swapped row in
        // portalBaseFinalItems — the map is keyed by weekly_item_id so
        // each row has its own swap entry (was previously keyed by
        // item_name, which collapsed duplicates like two Bananas).
        var nowIso = new Date().toISOString();
        var swapsApplied = [];
        (portalBaseFinalItems || []).forEach(function (it) {
          var swKey = (it && (it.weekly_item_id || it.item_name)) || '';
          var sw = swaps[swKey];
          if (!sw || !sw.swapped) return;
          var newName = sw.name || '';
          if (!newName || newName === it.item_name) return;
          swapsApplied.push({
            added:   { item_name: newName },
            removed: { item_name: it.item_name },
            swapped_at: nowIso
          });
        });
        var url = SB_URL_W + '/rest/v1/customer_boxes?id=eq.' +
                  encodeURIComponent(portalCurrentBoxId);
        var payload = {
          final_items: newFinalItems,
          swaps_applied: swapsApplied,
          box_size: vegSize || null,
          add_ons: buildAddOnsFromLocalCart(),
          edited_by_customer: true,
          updated_at: new Date().toISOString()
        };
        return fetch(url, {
          method: 'PATCH',
          headers: {
            apikey: SB_ANON_W,
            Authorization: 'Bearer ' + SB_ANON_W,
            'Content-Type': 'application/json',
            Prefer: 'return=representation'
          },
          body: JSON.stringify(payload)
        }).then(function (r) {
          if (!r.ok) {
            return r.text().then(function (t) {
              console.error('portal-swap commit HTTP ' + r.status, t);
              return null;
            });
          }
          return r.json();
        }).catch(function (e) {
          console.error('portal-swap commit failed', e);
          return null;
        });
      }
      window.__ffPortalSwapCommit = commitPortalSwapToSupabase;

      window.__customerBoxPromise.then(function (box) {
        // Sort the Supabase-supplied list alphabetically on load. User-side
        // swaps replace an item in place, so post-swap order is preserved
        // intentionally (not re-sorted).
        if (box && Array.isArray(box.final_items)) {
          box.final_items = box.final_items.slice().sort(function (a, b) {
            return String(a && a.item_name || '').localeCompare(String(b && b.item_name || ''));
          });
        }
        if (box && box.id) portalCurrentBoxId = box.id;
        if (box && Array.isArray(box.final_items)) portalBaseFinalItems = box.final_items;
        _swapWindowBoxAL = box || null;
        applySwapWindowState(box);
        applySizeLockState(box);
        if (!box) {
          // No customer_boxes row for this cycle yet (Supabase row not
          // pre-generated for the sub, or generation lagging behind).
          // The swap area is already locked via applySwapWindowState
          // above (baseWin=null → ff-swap-locked class). The menu itself
          // should still render — visible ≠ editable. Fall through to
          // the same loadWeeklyMenu path non-portal-swap subs use so
          // the customer sees this week's items even though they can't
          // swap them.
          loadWeeklyMenu(warehouse).then(function (menu) {
            if (!menu || !Array.isArray(menu.items)) { renderMenuError(); return; }
            currentItems = menu.items;
            renderItems(currentItems, vegSize);
          });
          // Even without an upcoming row, still show the customer's stored
          // permanent exclusions + last-known box size by reading from the
          // newest past customer_boxes row. Read-only — swap-window logic
          // above already ran with `null` so editing stays locked.
          if (window.__customerBoxLatestPromise) {
            window.__customerBoxLatestPromise.then(function (past) {
              if (!past) return;
              try {
                var pastSize = (past.box_size && String(past.box_size).toUpperCase()) || '';
                if (['X', 'S', 'M', 'B'].indexOf(pastSize) !== -1) {
                  vegSize = pastSize;
                  setActiveSize(document.querySelector('#drawer-veg .ff-size-grid'), vegSize);
                  applyDrawerHead('veg', vegSize);
                }
              } catch (e) {}
            });
          }
          // Cart-modal droprow renders async — kick the shared re-fill
          // so its .ff-cart-locked-block spans pick up the fresh window
          // set by applySwapWindowState's Appstle fetch (otherwise they
          // keep showing the Liquid defaults "Wed 3pm / Sat 9pm").
          syncPortalRescueAndCartSoon();
          return;
        }
        var finalItems = Array.isArray(box.final_items) ? box.final_items : [];
        var vegSizeMap0 = (window.__ffBoxData && window.__ffBoxData.veg) || {};
        // Supabase customer_boxes row is the source of truth for this
        // delivery. Do NOT read size from localCart — it belongs to the
        // step-flow draft and can pollute this view with an unrelated size.
        var portalSize = (box.box_size && String(box.box_size).toUpperCase()) || vegSize;
        if (['X', 'S', 'M', 'B'].indexOf(portalSize) === -1) portalSize = vegSize;
        vegSize = portalSize;
        // Build the portal swaps map from final_items[].swap_source.
        //   exclusion_rotation / exclusion_fallback → substitute (server
        //     replaced an excluded item; mark .swapped=true so the UI
        //     shows the row as a swap, plus .substituted=true for the
        //     "(substitute)" badge if other code wants it).
        //   customer_swap → user-initiated swap (no substitute).
        portalSwapsMap = {};
        finalItems.forEach(function (fi) {
          var src = fi && fi.swap_source;
          if (src === 'exclusion_rotation' || src === 'exclusion_fallback' || src === 'customer_swap') {
            var mapKey = (fi.weekly_item_id || fi.item_name);
            portalSwapsMap[mapKey] = {
              name: fi.item_name,
              funkyId: fi.funky_item_id || null,
              swapped: true,
              substituted: (src !== 'customer_swap')
            };
          }
        });
        // Customer's permanent exclusion preferences — already a plain
        // array of names in Supabase (e.g. ["Grapefruit","Lettuce"]).
        // exclusions_applied is the per-delivery resolved object list,
        // wrong shape for the Permanent Exclusions UI.
        // Exclusions are loaded independently from the fresh subscription.
        portalCustomerSize = vegSize;
        portalCustomerItems = finalItems.map(function (fi) {
          return {
            item_name: fi.item_name,
            funky_item_id: fi.funky_item_id || null,
            weekly_item_id: fi.weekly_item_id || null,
            weekly_box_items: [{ box_size: vegSize, quantity: Number(fi.quantity) || 1 }]
          };
        });
        currentItems = portalCustomerItems;
        // Also pull the weekly menu for this customer's warehouse —
        // size-switching in the drawer should fall back to default
        // menu items for sizes the customer hasn't actually chosen.
        var whWeekly = String(box.warehouse || '').toLowerCase() || warehouse;
        loadWeeklyMenu(whWeekly).then(function (menu) {
          if (menu && Array.isArray(menu.items)) portalWeeklyItems = menu.items;
        }).catch(function () { /* not fatal */ });
        // Re-sync the box card + drawer chrome to the Supabase size so
        // the chip / title / price reflect the subscription's actual
        // box, not the step-flow recommendation.
        setActiveSize(vegCard, vegSize);
        setActiveSize(document.querySelector('#drawer-veg .ff-size-grid'), vegSize);
        applyBoxData(vegCard, 'veg', vegSize);
        applyDrawerHead('veg', vegSize);
        renderItems(currentItems, vegSize);
        // Cart-modal row reflects Appstle subscription state (loaded into
        // localCart by the legacy bootstrap). Force-sync to the Supabase
        // box_size so all 3 surfaces (drawer / rescue card / cart row)
        // agree. Bounded retries because localCart may still be empty if
        // the bootstrap fetch is still in flight.
        (function () {
          var tries = 0;
          var tick = function () {
            tries++;
            try {
              var raw = localStorage.getItem('localCart');
              var cart = raw ? JSON.parse(raw) : [];
              if (Array.isArray(cart) && cart.length) {
                syncSizeToLocalCart('veg', vegSize);
                return;
              }
            } catch (e) {}
            if (tries < 40) setTimeout(tick, 250); // ~10s
          };
          tick();
        })();
        // portalExclusions was empty at the first render; re-paint the
        // Permanent Exclusions tab + chip strip now that the row is in.
        renderExclusions();
        renderExclChips(portalExclusions);
        // Push to the three downstream surfaces (rescue card, localCart,
        // cart-modal DOM). Bounded retry covers the case where the cart
        // table renders after this promise resolves.
        syncPortalRescueAndCartSoon();
      }).catch(function (e) {
        console.error('portal-swap load error:', e);
        renderMenuError();
      });
    } else {
      loadWeeklyMenu(warehouse).then(function (menu) {
        if (!menu || !Array.isArray(menu.items)) {
          renderMenuError();
          return;
        }
        currentItems = menu.items;
        renderItems(currentItems, vegSize);
      });
      // Non-allowlist on /collections/update-products: drawer's Permanent
      // Exclusions + cart-modal's Excluding line must reflect the
      // subscription's Supabase row, not whatever was previously saved
      // to ffNewFlow.exclusions during a step flow. Re-paint both once
      // the box resolves. (Allowlist runs the portal-swap branch above
      // which already handles this.)
      if (window.__customerBoxPromise) {
        // Non-allowlist commit-to-Supabase: writes only the two fields
        // these users can edit (box_size + exclusions). Same row id +
        // table as the allowlist's commitPortalSwapToSupabase. Cart-
        // modal already awaits window.__ffPortalSwapCommit() before
        // calling the Worker, so wiring our function under the same
        // global handles both flows from a single call site.
        var _nonAllowlistBoxId = null;
        var _nonAllowlistBox   = null;  // full row cached so commit can recompute the swap window
        var SB_URL_NA  = 'https://eaagqdyrbdlahjzdppdk.supabase.co';
        var SB_ANON_NA = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVhYWdxZHlyYmRsYWhqemRwcGRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc1OTk3NDEsImV4cCI6MjA4MzE3NTc0MX0.tnteB3igOKfgXKGTDEfRiq7TcxZIKLe3wSufhBVoiJk';
        window.__ffPortalSwapCommit = function () {
          if (!_nonAllowlistBoxId) return Promise.resolve(null);
          // Outside [open, close) → only Appstle gets the edit, never
          // Supabase.
          if (!isInSwapWindow(computeSwapWindow(_nonAllowlistBox))) {
            return Promise.resolve(null);
          }
          var url = SB_URL_NA + '/rest/v1/customer_boxes?id=eq.' +
                    encodeURIComponent(_nonAllowlistBoxId);
          var payload = {
            box_size: vegSize || null,
            add_ons: buildAddOnsFromLocalCart(),
            edited_by_customer: true,
            updated_at: new Date().toISOString()
          };
          return fetch(url, {
            method: 'PATCH',
            headers: {
              apikey: SB_ANON_NA,
              Authorization: 'Bearer ' + SB_ANON_NA,
              'Content-Type': 'application/json',
              Prefer: 'return=representation'
            },
            body: JSON.stringify(payload)
          }).then(function (r) {
            if (!r.ok) {
              return r.text().then(function (t) {
                console.error('non-allowlist box_size/exclusions commit HTTP ' + r.status, t);
                return null;
              });
            }
            return r.json();
          }).catch(function (e) {
            console.error('non-allowlist box_size/exclusions commit failed', e);
            return null;
          });
        };

        window.__customerBoxPromise.then(function (box) {
          // Size-lock applies to all update-products users, not just the
          // portal-swap allowlist — Shopify changes after billing affect
          // the *next* cycle while fulfilment reads Supabase, so a size
          // change in the billing→label-making window mis-prices the
          // already-billed order.
          applySizeLockState(box);
          _nonAllowlistBox = box || null;
          if (box && box.id) _nonAllowlistBoxId = box.id;
          // Permanent exclusions are initialized by the subscription request below.
        }).catch(function () {});
      }
    }

    function renderMenuError() {
      var msg = "We couldn't load this week's menu. Please try again shortly.";
      if (inclListEl) {
        inclListEl.innerHTML = '<p class="ff-incl-error" style="padding:24px 16px; text-align:center; color:#9b1b1b;">' +
          msg + '</p>';
      }
      // Swap candidates come from a separate Shopify collection and are
      // unaffected by a weekly-menu fetch failure.
    }

    function persistSizes() {
      // Portal mode: subscription + Supabase are the source of truth; the
      // user must hit checkout-design-btn to commit. Skip local persistence
      // so a refresh re-fetches the actual saved state.
      if (_ffIsPortalSwap) return;
      lsSet('ffNewFlow.boxSizes', { veg: vegSize, meat: meatSize, savedAt: Date.now() });
    }

    function updateSubtotal() {
      var subtotalEl = document.querySelector('[data-ff-subtotal]');
      if (!subtotalEl) return;
      var data = window.__ffBoxData || {};
      var total = 0;
      // Skip a card that's been dismissed by the customer (× click) so
      // the subtotal reflects what actually gets pushed into the cart.
      // Query fresh each call — updateSubtotal fires before the outer
      // vegCardEl/meatCardEl closure vars are assigned on some init
      // paths, so relying on them can miss a visible veg box.
      var _vegCard = document.querySelector('.ff-box-card[data-ff-box="veg"]');
      var vegHidden = !_vegCard || _vegCard.style.display === 'none';
      if (!vegHidden) {
        var vegPick = data.veg && data.veg[vegSize];
        if (vegPick) total += Number(vegPick.price) || 0;
      }
      var _meatCard = document.querySelector('.ff-box-card[data-ff-box="meat"]');
      var meatHidden = !_meatCard || _meatCard.style.display === 'none';
      if (!meatHidden) {
        var meatPick = data.meat && data.meat[meatSize];
        if (meatPick) total += Number(meatPick.price) || 0;
      }
      subtotalEl.textContent = '$' + (total / 100).toFixed(2);
    }

    // Outer card size chips — immediate effect (commit + outer-card UI).
    function bindOuterSize(card, kind) {
      if (!card) return;
      card.querySelectorAll('.ff-box-card__sizes [data-size]').forEach(function (el) {
        el.addEventListener('click', function () {
          var s = el.getAttribute('data-size');
          if (!s) return;
          if (kind === 'veg') {
            if (s === vegSize) return;
            vegSize = s;
            setActiveSize(card, s);
            applyBoxData(card, 'veg', s);
            // Keep drawer in sync (its head + items list) so a subsequent
            // open shows the right initial state.
            applyDrawerHead('veg', s);
            if (_ffIsPortalSwap) {
              currentItems = (s === portalCustomerSize) ? portalCustomerItems : portalWeeklyItems;
            }
            renderItems(currentItems, s);
            if (_ffIsPortalSwap) syncPortalRescueAndCart();
          } else {
            if (s === meatSize) return;
            meatSize = s;
            setActiveSize(card, s);
            applyBoxData(card, 'meat', s);
            applyDrawerHead('meat', s);
          }
          persistSizes();
          updateSubtotal();
        });
      });
    }

    // Portal Swap A: project Supabase customer_boxes state onto the three
    // user-visible surfaces (rescue-box card, cart-modal Excluding line,
    // localCart attribute). Light DOM patches + localCart write; idempotent
    // and safe to call repeatedly. NO body MutationObserver — the previous
    // implementation's observer on document.body looped with its own DOM
    // writes and hung the page.
    function syncPortalRescueAndCart() {
      if (!_ffIsPortalSwap) return;
      // Re-fill cart-modal locked-block dates: the droprow may be created
      // by cart-modal-slider *after* applySwapWindowState ran, so the
      // initial _fillLockedDates pass had nothing to write to.
      if (window.__ffLastDisplayedWin && window.__ffFillLockedDates) {
        try { window.__ffFillLockedDates(window.__ffLastDisplayedWin); } catch (e) {}
      }
      var sizeMap = (window.__ffBoxData && window.__ffBoxData.veg) || {};
      var vegVariantIds = {};
      Object.keys(sizeMap).forEach(function (k) {
        var v = sizeMap[k] && (sizeMap[k].variantId || sizeMap[k].id);
        if (v) vegVariantIds[String(v)] = 1;
      });
      var exclText = (portalExclusions && portalExclusions.length)
        ? portalExclusions.join(', ') : '';
      // box items: prefer the drawer's rendered names — they already
      // reflect the current size, user swaps (portalSwapsMap) and any
      // substitute resolutions. Fall back to portalCustomerItems only
      // when the drawer hasn't painted yet.
      var boxItemNames = [];
      if (inclListEl) {
        boxItemNames = Array.prototype.slice
          .call(inclListEl.querySelectorAll('.ff-incl-item__name'))
          .map(function (el) { return (el.textContent || '').trim(); })
          .filter(Boolean);
      }
      if (!boxItemNames.length && portalCustomerItems && portalCustomerItems.length) {
        boxItemNames = portalCustomerItems
          .map(function (it) { return (it && it.item_name) || ''; })
          .filter(Boolean);
      }

      // 1) Rescue box card (.collection-item.fruit-and-veg)
      var fvItem = document.querySelector('.collection-item.fruit-and-veg');
      var pick = sizeMap[vegSize];
      var wantedId = pick && (pick.variantId || pick.id);
      if (fvItem && wantedId) {
        fvItem.querySelectorAll('.customise-product-box').forEach(function (box) {
          var thisId = box.getAttribute('data-id');
          if (String(thisId) === String(wantedId)) box.classList.remove('hidden');
          else box.classList.add('hidden');
        });
      }
      var visibleBox = fvItem && fvItem.querySelector('.customise-product-box:not(.hidden)');
      var attrEl = visibleBox && visibleBox.querySelector('.box-attributes-text');
      if (attrEl) {
        var rescueHtml = '';
        // When inside the swap-open window, surface the edit deadline
        // above Excluding so customers know when changes lock. Mirrors
        // the locked-state "Edit until: <weekday DD Mon 8pm>" copy.
        try {
          // Use the window actually painted by applySwapWindowState
          // (may be projected forward when the Supabase row is stale,
          // or have its close overridden by Appstle nextBillingDate).
          // Recomputing from raw _swapWindowBoxAL misses both cases →
          // "Edit until billing" line silently drops in the swap-open
          // state on subs whose Supabase row hasn't rolled forward yet.
          var _winOpen = window.__ffLastDisplayedWin
            || (_swapWindowBoxAL ? computeSwapWindow(_swapWindowBoxAL) : null);
          if (_winOpen && isInSwapWindow(_winOpen)) {
            var _b = new Date(_winOpen.close.getTime() + 10 * 3600000);
            var _wd = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][_b.getUTCDay()];
            var _mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][_b.getUTCMonth()];
            rescueHtml += '<p class="ff-rescue-edit-until"><strong>Edit until billing:</strong><br>' + _wd + ' ' + _b.getUTCDate() + ' ' + _mo + ' 8pm</p>';
          }
        } catch (e) {}
        if (exclText) {
          rescueHtml += '<p><strong>Excluding: ' + escapeHtml(exclText) + '</strong></p>';
        }
        boxItemNames.slice(0, 7).forEach(function (n) {
          rescueHtml += '<p>' + escapeHtml(n) + '</p>';
        });
        if (boxItemNames.length > 7) rescueHtml += '<p>...</p>';
        // Idempotency guard: only write when content actually differs, so
        // any external MutationObservers don't see a no-op churn.
        if (attrEl.innerHTML !== rescueHtml) attrEl.innerHTML = rescueHtml;
      }

      // 2) localCart properties (so cart-modal re-renders use this value)
      try {
        var lcRaw = localStorage.getItem('localCart');
        var lc = lcRaw ? JSON.parse(lcRaw) : [];
        if (Array.isArray(lc)) {
          var changed = false;
          lc.forEach(function (it) {
            var vid = it && (it.variantId || it.id);
            if (!vid || !vegVariantIds[String(vid)]) return;
            if (!it.properties) it.properties = {};
            var prevExcl = it.properties.Excluding || '';
            var prevBox = it.properties['Box items'] || '';
            var newExcl = exclText;
            var newBox = boxItemNames.join(', ');
            if (prevExcl !== newExcl) {
              if (newExcl) it.properties.Excluding = newExcl;
              else delete it.properties.Excluding;
              changed = true;
            }
            if (prevBox !== newBox) {
              if (newBox) it.properties['Box items'] = newBox;
              else delete it.properties['Box items'];
              changed = true;
            }
          });
          if (changed) localStorage.setItem('localCart', JSON.stringify(lc));
        }
      } catch (e) {}

      // 3) Live cart-modal DOM patch — the Excluding line lives in the
      //    droprow appended right after the main CartItem row.
      document.querySelectorAll('tr[id^="CartItem-"]').forEach(function (row) {
        var m = row.id.match(/^CartItem-(\d+)-/);
        if (!m || !vegVariantIds[m[1]]) return;
        var lists = row.querySelector('.cart-product--list-info .lists');
        if (!lists && row.nextElementSibling) {
          lists = row.nextElementSibling.querySelector('.cart-product--list-info .lists');
        }
        if (!lists) return;
        var existing = null;
        Array.prototype.slice.call(lists.querySelectorAll('.list')).some(function (l) {
          if (/^Excluding:/.test((l.textContent || '').trim())) { existing = l; return true; }
          return false;
        });
        // Excluding line suppressed per 2026-07-08 spec. Strip only.
        if (existing) existing.parentNode.removeChild(existing);
      });
    }

    // Bounded retry — the cart-modal rows may render in a future tick when
    // the legacy bootstrap's subscription fetch resolves. Fire-and-forget,
    // no observer, no cascade.
    function syncPortalRescueAndCartSoon() {
      syncPortalRescueAndCart();
      setTimeout(syncPortalRescueAndCart, 400);
      setTimeout(syncPortalRescueAndCart, 1500);
      // The Liquid section's own script re-renders .box-attributes-text
      // from SubscriptionCart whenever the legacy bootstrap's subscription
      // fetch resolves; that can land after our 1.5s tick and wipe the
      // "Edit until billing" line. Extra trailing retries cover the race.
      setTimeout(syncPortalRescueAndCart, 3000);
      setTimeout(syncPortalRescueAndCart, 6000);
    }

    // Drawer-internal size grids — immediate (same as outer card chip).
    function bindDrawerSize(grid, kind) {
      if (!grid) return;
      grid.querySelectorAll('[data-size]').forEach(function (el) {
        el.addEventListener('click', function () {
          var s = el.getAttribute('data-size');
          if (!s) return;
          if (kind === 'veg') {
            if (s === vegSize) return;
            vegSize = s;
            // 1) Immediate-paint work: the .is-active class toggle on the
            //    grid + outer card chip + drawer head text. Anything
            //    user-visible stays in this tick so the browser paints
            //    the new active state before yielding.
            setActiveSize(vegCard, s);
            applyBoxData(vegCard, 'veg', s);
            applyDrawerHead('veg', s);
            // 2) Heavy work (item-list rebuild + cart/rescue sync) on
            //    the next frame — keeps the active-state paint from
            //    being blocked by ~50ms of layout work.
            requestAnimationFrame(function () {
              if (_ffIsPortalSwap) {
                currentItems = (s === portalCustomerSize) ? portalCustomerItems : portalWeeklyItems;
              }
              renderItems(currentItems, s);
              if (_ffIsPortalSwap) syncPortalRescueAndCart();
            });
          } else {
            if (s === meatSize) return;
            meatSize = s;
            setActiveSize(meatCardEl, s);
            applyBoxData(meatCardEl, 'meat', s);
            applyDrawerHead('meat', s);
          }
          persistSizes();
          updateSubtotal();
          // Heavy cart-side work — defer to a future frame so the size
          // grid's active-state paint isn't blocked by updateCartUI
          // (zone fetch + discount recalc, ~50ms).
          requestAnimationFrame(function () {
            if (!vegCard || _ffIsPortalSwap) syncSizeToLocalCart(kind, s);
          });
        });
      });
    }

    function syncSizeToLocalCart(kind, size) {
      var cart;
      try { cart = JSON.parse(localStorage.getItem('localCart') || '[]'); } catch (e) { return; }
      if (!Array.isArray(cart) || !cart.length) return;
      var data = window.__ffBoxData || {};
      var sizeMap = data[kind] || {};
      var newPick = sizeMap[size];
      if (!newPick || !newPick.id) return;
      var validIds = {};
      Object.keys(sizeMap).forEach(function (k) {
        if (sizeMap[k] && sizeMap[k].id) validIds[String(sizeMap[k].id)] = 1;
      });
      // Meat drawer opened via a specific cart row's pencil → only touch
      // THAT row. cart-modal-slider._wireMeatDrawerContext records the
      // (variantId, sellingPlan) of the clicked row. When no row-scoped
      // context is set (e.g. drawer opened from the step-4 order chip),
      // the loop falls back to the legacy blanket-update behaviour.
      var meatCtx = (kind === 'meat' && window.__ffMeatEditContext) ? window.__ffMeatEditContext : null;
      // Collect (oldVariantId, sellingPlan, mutated item, idx) tuples so we
      // can do in-place DOM swaps + post-mutate merge.
      var updates = [];
      cart.forEach(function (item, idx) {
        if (!item || !validIds[String(item.productId)]) return;
        if (meatCtx) {
          if (String(item.variantId) !== String(meatCtx.variantId)) return;
          if (String(item.sellingPlan) !== String(meatCtx.sellingPlan)) return;
        }
        var oldVariantId = item.variantId;
        var sellingPlan = item.sellingPlan;
        item.productId = String(newPick.id);
        item.productHandle = newPick.handle;
        item.variantId = Number(newPick.variantId) || Number(newPick.id);
        item.price = (Number(newPick.price) || 0) / 100;
        item.compare_at_price = (Number(newPick.compareAtPrice) || 0) / 100;
        item.productName = newPick.title;
        item.productImage = newPick.image;
        item.productAvailable = newPick.available !== false;
        updates.push({ oldVariantId: oldVariantId, sellingPlan: sellingPlan, item: item, idx: idx });
      });
      if (!updates.length) return;

      // Merge duplicates: if the updated item now shares (variantId,
      // sellingPlan) with another item in cart, absorb its quantity and
      // splice the sibling out. Same semantics as cart-modal-slider's
      // pill-flip handler — a row after size change may collide with an
      // existing every-order/one-off row of the new size.
      var didMerge = false;
      updates.forEach(function (u) {
        var target = u.item;
        var mergeIdx = cart.findIndex(function (it, i) {
          return i !== u.idx && it &&
            String(it.variantId) === String(target.variantId) &&
            String(it.sellingPlan) === String(target.sellingPlan);
        });
        if (mergeIdx >= 0) {
          target.quantity = (Number(target.quantity) || 0) + (Number(cart[mergeIdx].quantity) || 0);
          cart.splice(mergeIdx, 1);
          didMerge = true;
        }
      });
      try { localStorage.setItem('localCart', JSON.stringify(cart)); } catch (e) {}
      // Meat context is single-use — clear it now so the next drawer
      // open (unless a different pencil is clicked first) can't reuse
      // stale row identity.
      if (meatCtx) window.__ffMeatEditContext = null;

      // Always full-rebuild the table. A surgical DOM patch (rename row
      // id + price class only) leaves stale variantId references on the
      // pill buttons' data-variant-id, on the qty +/- and remove
      // buttons' inline updateQuantity(oldVariantId,…) onclicks, on the
      // .model-quantity-display-{old}-{plan} class, and on
      // #not-available-{old}. Those handlers then look up cart items by
      // the old variantId and silently no-op. Correctness > flicker.
      if (typeof window.appendTableFunction === 'function') {
        try { window.appendTableFunction(true).catch(function () {}); } catch (e) {}
      }

      // Sync product-card Add/qty state on the shop grid for both the
      // old-size variants (should flip back to "Add") and the new-size
      // variants (should show the current qty). appendTableFunction
      // rebuilds the cart popup but doesn't touch the outer product
      // cards, so without this the old card stays showing qty and the
      // new card stays showing Add.
      if (typeof updateProductCardsUI === 'function') {
        var _touchedVariantIds = {};
        updates.forEach(function (u) {
          if (u && u.oldVariantId) _touchedVariantIds[String(u.oldVariantId)] = 1;
          if (u && u.item && u.item.variantId) _touchedVariantIds[String(u.item.variantId)] = 1;
        });
        Object.keys(_touchedVariantIds).forEach(function (vid) {
          var _qty = cart.reduce(function (sum, it) {
            return sum + ((it && String(it.variantId) === vid) ? (Number(it.quantity) || 0) : 0);
          }, 0);
          try { updateProductCardsUI(Number(vid), _qty); } catch (e) {}
        });
      }

      // Re-evaluate the "Add 100% grass fed beef?" carousel — the size
      // change may mean a previously-in-cart card should reappear (moved
      // to a different size / plan) or the newly-picked size's card
      // should disappear.
      if (typeof window.updateAddOnItemsDisplay === 'function' ||
          typeof updateAddOnItemsDisplay === 'function') {
        try {
          var _fn = (typeof updateAddOnItemsDisplay === 'function')
            ? updateAddOnItemsDisplay
            : window.updateAddOnItemsDisplay;
          var _allHidden = _fn(cart);
          var _slider = document.querySelector('.cart-slider.cart-beef-slider');
          if (_slider) _slider.style.display = _allHidden ? 'none' : '';
        } catch (e) {}
      }

      // updateCartUI(null, true) keeps discount + zone calc correct.
      // Yes it adds a small delay, but skipping it would briefly show
      // the wrong total whenever a discount code is applied.
      if (typeof window.updateCartUI === 'function') {
        try { window.updateCartUI(null, true); } catch (e) {}
      } else if (typeof window._updateCartBadge === 'function') {
        try { window._updateCartBadge(cart); } catch (e) {}
      }
    }

    bindOuterSize(vegCard, 'veg');
    bindOuterSize(meatCardEl, 'meat');
    bindDrawerSize(document.querySelector('#drawer-veg .ff-size-grid'), 'veg');
    bindDrawerSize(document.querySelector('#drawer-meat .ff-size-grid'), 'meat');

    // Initial paint: outer card + drawer head reflect stored sizes.
    setActiveSize(vegCard, vegSize);
    applyBoxData(vegCard, 'veg', vegSize);
    applyDrawerHead('veg', vegSize);
    if (meatCardEl) {
      setActiveSize(meatCardEl, meatSize);
      applyBoxData(meatCardEl, 'meat', meatSize);
      applyDrawerHead('meat', meatSize);
    }
    updateSubtotal();

    // Update button — drawer changes are already applied immediately,
    // so this is just a "close" alias. Routes through the drawer's
    // own close trigger so the handoff drawer-stack stays balanced.
    function closeDrawerById(id) {
      var drawer = document.getElementById(id);
      if (!drawer) return;
      var closer = drawer.querySelector('[data-drawer-close]');
      if (closer) closer.click();
    }
    document.querySelectorAll('[data-drawer-update]').forEach(function (btn) {
      var drawer = btn.closest('.ff-drawer');
      var id = drawer && drawer.id;
      if (!id) return;
      btn.addEventListener('click', function () {
        // Sync drawer state back to any existing localCart entry for the
        // matching box, so changes made in the cart UI persist into the
        // legacy cart properties (Box items + Excluding). On 2095 the
        // user hasn't gone through Shop add ons yet so localCart has no
        // matching entry — that's fine, this is a no-op there.
        // Portal mode also skips this — same reason as the size-switch
        // path: no localCart to mutate, and updateCartUI(null, true)
        // dominates the perceived lag. Future A2/A3 will route the commit
        // through Supabase here instead.
        if (!_ffIsPortalSwap) {
          if (id === 'drawer-veg') syncDrawerToLocalCart('veg');
          if (id === 'drawer-meat') syncDrawerToLocalCart('meat');
        }
        closeDrawerById(id);
      });
    });

    function syncDrawerToLocalCart(kind) {
      var cart;
      try { cart = JSON.parse(localStorage.getItem('localCart') || '[]'); } catch (e) { return; }
      if (!Array.isArray(cart) || !cart.length) return;
      var data = window.__ffBoxData || {};
      var sizeMap = data[kind] || {};
      var validIds = {};
      Object.keys(sizeMap).forEach(function (k) {
        if (sizeMap[k] && sizeMap[k].id) validIds[String(sizeMap[k].id)] = 1;
      });
      var changed = false;
      cart.forEach(function (item) {
        if (!item || !validIds[String(item.productId)]) return;
        if (!item.properties) item.properties = {};
        if (kind === 'veg') {
          // Box items = current incl-list names; Excluding = saved drawer choices.
          var boxItemNames = inclListEl
            ? Array.prototype.slice
                .call(inclListEl.querySelectorAll('.ff-incl-item__name'))
                .map(function (el) { return (el.textContent || '').trim(); })
                .filter(Boolean)
            : [];
          var exclList = lsGet('ffNewFlow.exclusions') || [];
          if (boxItemNames.length) item.properties['Box items'] = boxItemNames.join(', ');
          else delete item.properties['Box items'];
          if (exclList.length) item.properties.Excluding = exclList.join(', ');
          else delete item.properties.Excluding;
          changed = true;
        }
      });
      if (changed) {
        try { localStorage.setItem('localCart', JSON.stringify(cart)); } catch (e) {}
        // Re-render the cart UI so list-info-content (Excluding / Box items)
        // reflects the just-saved drawer changes. Without this the localCart
        // entry is updated but the visible cart still shows the stale list.
        if (typeof window.updateCartUI === 'function') {
          try { window.updateCartUI(null, true); } catch (e) {}
        }
      }
    }

    // ---- Swap persistence ----
    // Snapshot the row's anchor name when the swap modal opens, then on
    // any swap-modal row click record { origName: newName } in
    // ffNewFlow.swaps. handoff JS already does the DOM swap; this layer
    // makes it survive refresh and contribute to the cart payload.
    var pendingSwapAnchor = null;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-swap-open]');
      if (!btn) return;
      // Swap window closed → block the modal from opening, tell the
      // customer why. Previously the click sailed through and the
      // silent commit-gate at commitPortalSwapToSupabase quietly
      // dropped the edit at save time.
      if (document.documentElement.classList.contains('ff-swap-locked')) {
        e.preventDefault();
        e.stopPropagation();
        var msg = 'Editing this box has closed for this cycle. Changes will apply from your next delivery.';
        if (typeof showToast === 'function') { try { showToast(msg, 4000); } catch (er) {} }
        return;
      }
      var row = btn.closest('.ff-incl-item');
      // Anchor by data-orig-key (unique per row) so two rows sharing
      // the same item_name each get their own swap entry. Keep the
      // original name too so the "user reselected the original" check
      // below still works.
      var _key = row && (row.getAttribute('data-orig-key') || row.getAttribute('data-orig-name'));
      var _name = row && row.getAttribute('data-orig-name');
      pendingSwapAnchor = _key ? { key: _key, name: _name || _key } : null;
      // Refresh which candidates are hidden (a product at the box cap must
      // not be selectable) before the modal becomes visible.
      updateSwapModalAvailability();
    });

    var swapModalEl = document.getElementById('swap-modal');
    if (swapModalEl) {
      swapModalEl.addEventListener('click', function (e) {
        var rowBtn = e.target.closest && e.target.closest('.ff-swap-modal__row');
        if (!rowBtn || !pendingSwapAnchor) return;
        var newName = rowBtn.getAttribute('data-swap-name') || '';
        if (!newName) return;
        var newIcon = rowBtn.getAttribute('data-swap-icon') || '';
        var newFunkyId = rowBtn.getAttribute('data-swap-funky-id') || '';
        // Fallback — recover funky_item_id from the WP-cached products
        // when the modal row didn't carry it.
        if (!newFunkyId) {
          var hit = ffProductsByTitleLC[newName.toLowerCase()];
          if (hit && hit.funky_item_id) newFunkyId = String(hit.funky_item_id);
        }
        // Portal Swap A: writes go to the in-memory portalSwapsMap so
        // applySubstitutions can see them immediately. No localStorage
        // persistence here — that step-flow store would just leak
        // unrelated subscriptions' swaps into other sessions. The real
        // write back to Supabase happens in a later phase.
        var swaps = _ffIsPortalSwap ? portalSwapsMap : (lsGet('ffNewFlow.swaps') || {});
        var anchorKey  = pendingSwapAnchor.key;
        var anchorName = pendingSwapAnchor.name;
        if (newName === anchorName) {
          // User reselected the menu's original — clear any swap.
          delete swaps[anchorKey];
        } else {
          // Save the user's raw choice. Substitute trigger now runs in
          // applySubstitutions on every render, so we don't pre-resolve
          // here — that keeps scenarios 1 + 2 working (substitute fires
          // whenever the intended item lands in the exclusion set, not
          // only at swap-pick moment).
          var entry = { name: newName };
          if (newIcon) entry.icon = newIcon;
          if (newFunkyId) entry.funkyId = newFunkyId;
          if (_ffIsPortalSwap) entry.swapped = true;
          swaps[anchorKey] = entry;
        }
        if (!_ffIsPortalSwap) lsSet('ffNewFlow.swaps', swaps);
        pendingSwapAnchor = null;
        applySubstitutions();
        if (_ffIsPortalSwap) syncPortalRescueAndCart();
      });
    }

    // Meat-box X (remove) — hide card + drawer, persist, recompute subtotal.
    // Also re-evaluate whether the veg remove button should stay visible —
    // once meat is gone, veg must be mandatory again.
    if (meatCardEl) {
      var removeBtn = meatCardEl.querySelector('.ff-box-card__remove');
      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          meatCardEl.style.display = 'none';
          var d = document.getElementById('drawer-meat');
          if (d) d.style.display = 'none';
          lsSet('ffNewFlow.hideMeatBox', true);
          // Meat is gone → veg is mandatory again. Ensure card is visible
          // and drop any lingering hideVegBox flag from a prior session.
          lsSet('ffNewFlow.hideVegBox', false);
          if (vegCardEl) vegCardEl.style.display = '';
          var vd0 = document.getElementById('drawer-veg');
          if (vd0) vd0.style.display = '';
          _refreshVegRemoveVisibility();
          updateSubtotal();
        });
      }
    }

    // Veg-box X — mirrors meat's remove, but only exposed when a meat box
    // is present on the step. Removes the card + drawer + persists a flag
    // that buildLocalCartAndGo() reads to skip adding the veg line.
    var vegCardEl = document.querySelector('.ff-box-card[data-ff-box="veg"]');
    var vegRemoveBtnEl = document.querySelector('[data-ff-veg-remove]');
    var meatRemoveBtnEl = document.querySelector('[data-ff-meat-remove]');
    function _isMeatPresentOnStep() {
      // If the section markup / diet preference hid the meat card, or the
      // user already dismissed it, treat meat as absent.
      if (!meatCardEl) return false;
      if (meatCardEl.style.display === 'none') return false;
      if (lsGet('ffNewFlow.hideMeatBox') === true) return false;
      var diet = lsGet('ffNewFlow.dietary');
      if (diet === 'vegetarian' || diet === 'vegan') return false;
      return true;
    }
    function _isVegPresentOnStep() {
      if (!vegCardEl) return false;
      if (vegCardEl.style.display === 'none') return false;
      if (lsGet('ffNewFlow.hideVegBox') === true) return false;
      return true;
    }
    function _isSubMeatPresentOnStep() {
      // A one-off meat box doesn't hold the subscription for veg —
      // treat cadence==='oneoff' as no sub-meat present.
      if (!_isMeatPresentOnStep()) return false;
      return (lsGet('ffNewFlow.meatCadence') || 'every') !== 'oneoff';
    }
    function _refreshVegRemoveVisibility() {
      if (!vegRemoveBtnEl) return;
      // CSS forces display:inline-flex, so the HTML `hidden` attribute is
      // overridden. Use inline style to win the cascade.
      vegRemoveBtnEl.style.display = _isSubMeatPresentOnStep() ? '' : 'none';
    }
    function _refreshMeatRemoveVisibility() {
      if (!meatRemoveBtnEl) return;
      meatRemoveBtnEl.style.display = _isVegPresentOnStep() ? '' : 'none';
    }
    // If veg is not present on this step, disable "Deliver as one-off"
    // for the meat box: flipping the sole remaining box to one-off
    // would leave the subscription empty. Also snap cadence back to
    // 'every' if the user had it on 'oneoff' before removing veg.
    function _refreshMeatCadenceGate() {
      var oneoffBtn = document.querySelector('.ff-box-card[data-ff-box="meat"] .ff-box-card__deliver-tag[data-cadence="oneoff"]');
      var everyBtn = document.querySelector('.ff-box-card[data-ff-box="meat"] .ff-box-card__deliver-tag[data-cadence="every"]');
      if (!oneoffBtn) return;
      if (!_isVegPresentOnStep()) {
        oneoffBtn.setAttribute('disabled', 'disabled');
        oneoffBtn.style.opacity = '0.4';
        oneoffBtn.style.pointerEvents = 'none';
        if (oneoffBtn.classList.contains('is-active')) {
          oneoffBtn.classList.remove('is-active');
          if (everyBtn) everyBtn.classList.add('is-active');
          try { lsSet('ffNewFlow.meatCadence', 'every'); } catch (e) {}
        }
      } else {
        oneoffBtn.removeAttribute('disabled');
        oneoffBtn.style.opacity = '';
        oneoffBtn.style.pointerEvents = '';
      }
    }
    _refreshVegRemoveVisibility();
    _refreshMeatRemoveVisibility();
    _refreshMeatCadenceGate();
    if (vegCardEl && vegRemoveBtnEl) {
      vegRemoveBtnEl.addEventListener('click', function () {
        vegCardEl.style.display = 'none';
        var vd = document.getElementById('drawer-veg');
        if (vd) vd.style.display = 'none';
        lsSet('ffNewFlow.hideVegBox', true);
        _refreshMeatRemoveVisibility();
        _refreshMeatCadenceGate();
        updateSubtotal();
      });
    }

    // Meat cadence (subscription vs one-off) — toggle active + persist.
    var cadence = lsGet('ffNewFlow.meatCadence') || 'every';
    document.querySelectorAll('.ff-box-card__deliver-tag').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-cadence') === cadence);
      el.addEventListener('click', function () {
        var c = el.getAttribute('data-cadence');
        if (!c || c === cadence) return;
        // Guard: if the button is currently disabled by _refreshMeatCadenceGate
        // (veg absent), ignore the click.
        if (el.getAttribute('disabled')) return;
        cadence = c;
        document.querySelectorAll('.ff-box-card__deliver-tag').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-cadence') === c);
        });
        lsSet('ffNewFlow.meatCadence', c);
        // Cadence change flips whether the sub-meat "holds" the veg —
        // re-evaluate veg × visibility.
        _refreshVegRemoveVisibility();
      });
    });

    // Shop add ons — write localCart in legacy shape + navigate.
    var addonsBtn = document.querySelector('[data-ff-shop-addons]');
    if (addonsBtn) {
      addonsBtn.addEventListener('click', function () {
        try {
          if (typeof window.__ffTrack === 'function') {
            window.__ffTrack('ff_step_complete', { step_index: 5, step_name: 'order' }, { nextPage: true });
          }
        } catch (e) {}
        try {
          buildLocalCartAndGo();
        } catch (e) {
          console.error('Shop add ons failed:', e);
        }
      });
    }

    function buildLocalCartAndGo() {
      var data = window.__ffBoxData || {};
      var freqRaw = lsGet('ffNewFlow.frequency');
      var freq = (freqRaw && typeof freqRaw === 'object') ? freqRaw : null;
      var planId = (freq && freq.sellingPlanId) ||
                   (window.__sellingPlans && window.__sellingPlans.weekly) ||
                   2067431485;
      var planName = (freq && freq.value) || 'weekly';
      var deliveryObj = {};
      try { deliveryObj = JSON.parse(localStorage.getItem('deliverySuburbObj') || '{}') || {}; } catch (e) {}

      var cart = [];

      // Box-level properties (matches what cart-modal-slider / Appstle
      // subscription update actually consume — only Excluding and
      // "Box items"; "Replace with" is deprecated):
      //   Excluding  = manual exclusions from drawer checkboxes
      //   Box items  = the final item names in the box (post-swap)
      //                read from the current veg incl list DOM, no qty
      var exclList = lsGet('ffNewFlow.exclusions') || [];
      var boxItemNames = inclListEl
        ? Array.prototype.slice
            .call(inclListEl.querySelectorAll('.ff-incl-item__name'))
            .map(function (el) { return (el.textContent || '').trim(); })
            .filter(Boolean)
        : [];
      var vegProps = {};
      if (boxItemNames.length) vegProps['Box items'] = boxItemNames.join(', ');
      if (exclList.length) vegProps.Excluding = exclList.join(', ');

      var meatHidden = !meatCardEl || meatCardEl.style.display === 'none';
      // hideVegBox only applies while a meat box is still on the step —
      // once meat is gone, veg is mandatory again regardless of the flag.
      var vegHidden = !meatHidden && (
        (!vegCardEl || vegCardEl.style.display === 'none') || lsGet('ffNewFlow.hideVegBox') === true
      );
      var vegPick = data.veg && data.veg[vegSize];
      if (vegPick && !vegHidden) cart.push(buildCartItem(vegPick, planId, planName, deliveryObj, false, vegProps));
      var meatPick = data.meat && data.meat[meatSize];
      if (meatPick && !meatHidden) {
        if (cadence === 'oneoff') {
          cart.push(buildCartItem(meatPick, 'none', 'none', deliveryObj, true, {}));
        } else {
          cart.push(buildCartItem(meatPick, planId, planName, deliveryObj, false, {}));
        }
      }

      lsSet('localCart', cart);

      // Cart-level attribute that flows into the order → Appstle subscription
      // customAttributes (same key the customer-portal popup writes to).
      // Fire-and-forget; don't block the redirect on it.
      // Dietary attribute matches the customer-portal-new naming:
      // key "Dietary preferences", values "No restrictions" / "I'm vegetarian" /
      // "I'm vegan". `dietary` is one of "none" | "vegetarian" | "vegan".
      var dietAttr = dietary === 'vegetarian' ? "I'm vegetarian"
                   : dietary === 'vegan'      ? "I'm vegan"
                   :                            'No restrictions';
      // Household composition collected on Q1 — recorded as a single
      // cart attribute so it flows through to the order + Appstle
      // subscription customAttributes (used downstream for any
      // post-launch retuning of the recommendation formula).
      var household = lsGet('ffNewFlow.household') || {};
      var hhAdults = parseInt(household.adults, 10) || 0;
      var hhChildren = parseInt(household.children, 10) || 0;
      var householdAttr = hhAdults + ' adult' + (hhAdults === 1 ? '' : 's') +
                         ', ' + hhChildren + ' child' + (hhChildren === 1 ? '' : 'ren');
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: {
            'Dietary preferences': dietAttr,
            'Household size': householdAttr
          } }),
        }).catch(function () {});
      } catch (e) {}

      goWithLoading('/collections/shop-now', addonsBtn);
    }

    function buildCartItem(pick, sellingPlan, sellingPlanName, deliveryObj, asOneOff, properties) {
      var suburbCode = pick.suburbCode;
      if (typeof suburbCode === 'string') {
        try { suburbCode = JSON.parse(suburbCode); } catch (e) {}
      }
      return {
        productId: String(pick.id),
        productHandle: pick.handle,
        variantId: Number(pick.variantId) || Number(pick.id),
        quantity: 1,
        // Legacy localCart stores price/compare_at_price in DOLLARS (float).
        price: (Number(pick.price) || 0) / 100,
        compare_at_price: (Number(pick.compareAtPrice) || 0) / 100,
        productName: pick.title,
        productImage: pick.image,
        productAvailable: pick.available !== false,
        sellingPlan: sellingPlan,
        sellingPlanName: sellingPlanName,
        properties: properties || {},
        suburbCode: suburbCode || null,
        noProvider: pick.noProvider || [],
        noWarehouse: pick.noWarehouse || [],
        noZones: pick.noZones || [],
        isSuburbAvailable: true,
        discountItem: deliveryObj && deliveryObj.discountItem,
        deliveryPrice: (deliveryObj && deliveryObj.deliveryPrice) || 0,
        suburbCodeValue: (deliveryObj && deliveryObj.suburbCodeValue) || '',
        suburbStateValue: (deliveryObj && deliveryObj.suburbStateValue) || '',
        deliveryAddress: deliveryObj && deliveryObj.deliveryAddress,
        oneOff: asOneOff && pick.oneOffVariantId ? String(pick.oneOffVariantId) : 'none',
      };
    }
  }

  // Placeholder for item icons — handoff used a single swap-example image.
  // 2095 doesn't (yet) wire per-item image URLs; reuse the global swap example.
  window.__ffPlaceholderIcon = (document.querySelector('link[rel="canonical"]') && '') ||
    '/cdn/shop/files/swap-example.png';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  // Auto-clear onboarding state after a successful checkout.
  // cart-modal-slider stamps a timestamp + the pre-checkout cart token
  // right before redirecting to /checkouts/cn/.
  // On the next main-site page load:
  //   - if attempt was < 1h ago, the Shopify cart is empty, AND the cart
  //     token has changed → Shopify issued a fresh cart (i.e. the order
  //     went through) → wipe state
  //   - if cart is empty but token is unchanged → the user manually
  //     cleared the cart, NOT a successful checkout → leave state alone
  //     (drop the sentinel so we don't keep checking)
  //   - if cart still has items → user came back without checking out,
  //     do nothing
  //   - if attempt was > 1h ago → assume abandoned / expired, drop sentinel
  function maybeClearAfterCheckout() {
    var stampRaw, preToken;
    try {
      stampRaw = localStorage.getItem('ffNewFlow.checkoutAttempted');
      preToken = localStorage.getItem('ffNewFlow.preCheckoutCartToken');
    } catch (e) { return; }
    if (!stampRaw) return;
    var stamp = Number(stampRaw);
    function dropSentinel() {
      try {
        localStorage.removeItem('ffNewFlow.checkoutAttempted');
        localStorage.removeItem('ffNewFlow.preCheckoutCartToken');
      } catch (e) {}
    }
    if (!stamp || Date.now() - stamp > 60 * 60 * 1000) { dropSentinel(); return; }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        if (cart.item_count !== 0) return; // user came back without checkout
        if (preToken && cart.token && cart.token !== preToken) {
          clearFlowState();
        } else {
          // Cart was emptied but the token is unchanged → manual clear.
          // Just retire the sentinel; don't wipe onboarding state.
          dropSentinel();
        }
      })
      .catch(function () {});
  }

  function clearFlowState() {
    var keys = [
      'ffNewFlow.suburb', 'ffNewFlow.household', 'ffNewFlow.frequency',
      'ffNewFlow.dietary', 'ffNewFlow.boxSizes', 'ffNewFlow.chosenSize',
      'ffNewFlow.recommendedSize', 'ffNewFlow.recommendedMeatSize',
      'ffNewFlow.recommendation', 'ffNewFlow.exclusions', 'ffNewFlow.swaps',
      'ffNewFlow.meatCadence', 'ffNewFlow.hideMeatBox',
      'ffNewFlow.checkoutAttempted', 'ffNewFlow.preCheckoutCartToken', 'ffNewFlow.zonesCache',
      'localCart', 'localStepInfo', 'deliverySuburbObj',
    ];
    keys.forEach(function (k) {
      try { localStorage.removeItem(k); } catch (e) {}
    });
  }

  // ---------- GA4 funnel tracking (new-step flow) ----------
  // Emits ff_step_view on page load and ff_step_complete when the
  // user clicks the shared [data-ff-continue] button. Uses the
  // section root's data-ff-step attribute to derive step_name, and
  // maps it to a 1-based step_index for ordered funnels. The
  // ff_ prefix keeps this stream separate from the old
  // step_view / step_complete events (which fired on pre-2026-07
  // step-*.liquid pages and now sit dormant).
  // Order page (step 4) has no continue button — funnel closes on
  // Shopify's own begin_checkout event downstream.
  function initGA4Funnel() {
    var root = document.querySelector('[data-ff-step]');
    if (!root) return;
    var stepName = root.getAttribute('data-ff-step');
    var indexMap = { suburb: 1, household: 2, frequency: 3, dietary: 4, order: 5 };
    var stepIndex = indexMap[stepName];
    if (!stepIndex) return;
    var sendTo = window.__ffGa4MeasurementId || null;
    window.gtag = window.gtag || function () {
      (window.dataLayer = window.dataLayer || []).push(arguments);
    };
    var payload = { step_index: stepIndex, step_name: stepName };
    // All flow_variant / entry_source / send_to / dedupe / queue logic
    // lives in the central helper (ff-analytics.liquid). Only fall back
    // to raw gtag if the helper isn't loaded (should never happen post-
    // theme.liquid render).
    var _fire = function (name, opts) {
      if (typeof window.__ffTrack === 'function') {
        window.__ffTrack(name, payload, opts);
      } else {
        try { window.gtag('event', name, payload); } catch (e) {}
      }
    };
    _fire('ff_step_view');
    document.querySelectorAll('[data-ff-continue]').forEach(function (btn) {
      btn.addEventListener('click', function () { _fire('ff_step_complete', { nextPage: true }); });
    });
  }

  ready(function () {
    maybeClearAfterCheckout();
    init2090();
    init2092();
    initSingleSelect('frequency', 'ffNewFlow.frequency', '/pages/new-step-3-dietary');
    initSingleSelect('dietary', 'ffNewFlow.dietary', '/pages/new-step-4-order', { delayMs: 1500 });
    init2095();
    initGenericContinue();
    initGA4Funnel();
  });
})();
